/* tslint:disable */
/* eslint-disable */
/**
 * Multi-tenancy clinic API
 * API documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base";

/**
 *
 * @export
 * @interface AccessTokenOnlyDto
 */
export interface AccessTokenOnlyDto {
  /**
   *
   * @type {string}
   * @memberof AccessTokenOnlyDto
   */
  access_token?: string;
}
/**
 *
 * @export
 * @interface ApproveDto
 */
export interface ApproveDto {
  /**
   *
   * @type {boolean}
   * @memberof ApproveDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof ApproveDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof ApproveDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof ApproveDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof ApproveDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof ApproveDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof ApproveDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof ApproveDto
   */
  code: string;
  /**
   * PENDING | APPROVE | DECLINE
   * @type {string}
   * @memberof ApproveDto
   */
  status: string;
}
/**
 *
 * @export
 * @interface AuthenticationControllerAuthenticate201Response
 */
export interface AuthenticationControllerAuthenticate201Response {
  /**
   *
   * @type {string}
   * @memberof AuthenticationControllerAuthenticate201Response
   */
  message?: string;
  /**
   *
   * @type {TokenDto}
   * @memberof AuthenticationControllerAuthenticate201Response
   */
  data?: TokenDto;
}
/**
 *
 * @export
 * @interface AuthenticationControllerRefreshRenew201Response
 */
export interface AuthenticationControllerRefreshRenew201Response {
  /**
   *
   * @type {string}
   * @memberof AuthenticationControllerRefreshRenew201Response
   */
  message?: string;
  /**
   *
   * @type {RenewRefreshTokenDto}
   * @memberof AuthenticationControllerRefreshRenew201Response
   */
  data?: RenewRefreshTokenDto;
}
/**
 *
 * @export
 * @interface BillingControllerGet200Response
 */
export interface BillingControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof BillingControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetBillingDto>}
   * @memberof BillingControllerGet200Response
   */
  data?: Array<GetBillingDto>;
}
/**
 *
 * @export
 * @interface BlockPersonDto
 */
export interface BlockPersonDto {
  /**
   *
   * @type {boolean}
   * @memberof BlockPersonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof BlockPersonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof BlockPersonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof BlockPersonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof BlockPersonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof BlockPersonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof BlockPersonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof BlockPersonDto
   */
  code: string;
  /**
   * IF set as TRUE then the user will not be allowed to login ELSE the user will still be allowed to login.
   * @type {boolean}
   * @memberof BlockPersonDto
   */
  is_blocked?: boolean;
}
/**
 *
 * @export
 * @interface ContractControllerGet200Response
 */
export interface ContractControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof ContractControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetContractDto>}
   * @memberof ContractControllerGet200Response
   */
  data?: Array<GetContractDto>;
}
/**
 *
 * @export
 * @interface CoreApiPaginatedResponse
 */
export interface CoreApiPaginatedResponse {
  /**
   *
   * @type {number}
   * @memberof CoreApiPaginatedResponse
   */
  count?: number;
}
/**
 *
 * @export
 * @interface CreateActivityLogDto
 */
export interface CreateActivityLogDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateActivityLogDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  request_code?: string;
  /**
   * describes the database table source
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  request_source?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  tenant: string;
  /**
   * CREATE | UPDATE | DELETE
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  action: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  old_value?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  new_value?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateActivityLogDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface CreateAttachmentTypeDto
 */
export interface CreateAttachmentTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateAttachmentTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CreateAttachmentVisitBaseDto
 */
export interface CreateAttachmentVisitBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateAttachmentVisitBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  visit: string;
  /**
   *
   * @type {string}
   * @memberof CreateAttachmentVisitBaseDto
   */
  attachment?: string;
}
/**
 *
 * @export
 * @interface CreateBillingDto
 */
export interface CreateBillingDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateBillingDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateBillingDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBillingDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateBillingDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBillingDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateBillingDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBillingDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBillingDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateBillingDto
   */
  contract: string;
  /**
   *
   * @type {number}
   * @memberof CreateBillingDto
   */
  session: number;
}
/**
 *
 * @export
 * @interface CreateConfigDto
 */
export interface CreateConfigDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateConfigDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateConfigDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateConfigDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateConfigDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof CreateConfigDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface CreateContractBaseDto
 */
export interface CreateContractBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateContractBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  code?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateContractBaseDto
   */
  is_on_going?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  waiver?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  patient?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  signature?: string;
  /**
   *
   * @type {number}
   * @memberof CreateContractBaseDto
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof CreateContractBaseDto
   */
  person?: string;
}
/**
 *
 * @export
 * @interface CreateCreditTypeDto
 */
export interface CreateCreditTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateCreditTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateCreditTypeDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface CreateDebitTypeDto
 */
export interface CreateDebitTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateDebitTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDebitTypeDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface CreateItemDto
 */
export interface CreateItemDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateItemDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateItemDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateItemDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateItemDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof CreateItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof CreateItemDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface CreateLedgerDto
 */
export interface CreateLedgerDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateLedgerDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateLedgerDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateLedgerDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateLedgerDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateLedgerDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateLedgerDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateLedgerDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateLedgerDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateLedgerDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof CreateLedgerDto
   */
  type: string;
  /**
   * CREDIT | DEBIT
   * @type {string}
   * @memberof CreateLedgerDto
   */
  action: string;
  /**
   *
   * @type {string}
   * @memberof CreateLedgerDto
   */
  batch: string;
  /**
   *
   * @type {number}
   * @memberof CreateLedgerDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof CreateLedgerDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface CreatePatientBaseDto
 */
export interface CreatePatientBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  last_name: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  birthday?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  mobile_number?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  is_alergic_to_vitamins?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  is_pregnant?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  is_breast_feeding?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  has_past_hospitalization?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  past_hospitalization_reason?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  has_kidney_problem?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  has_cardiac_problem?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  is_hypertensive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  has_liver_problem?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  other_problems?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  is_taking_medication?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  medication_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  has_allergies?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  allergy_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  has_medical_conditions?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  medical_conditon_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePatientBaseDto
   */
  was_recently_unwell?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  unwell_details?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePatientBaseDto
   */
  other_medical_conditions?: string;
}
/**
 *
 * @export
 * @interface CreatePaymentBaseDto
 */
export interface CreatePaymentBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof CreatePaymentBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  billing: string;
  /**
   *
   * @type {number}
   * @memberof CreatePaymentBaseDto
   */
  amount_paid: number;
  /**
   * UNPAID | PENDING | PAID
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBaseDto
   */
  provider?: string;
}
/**
 *
 * @export
 * @interface CreatePaymentBulkBaseDto
 */
export interface CreatePaymentBulkBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof CreatePaymentBulkBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  contract: string;
  /**
   *
   * @type {number}
   * @memberof CreatePaymentBulkBaseDto
   */
  amount_paid: number;
  /**
   * UNPAID | PENDING | PAID
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePaymentBulkBaseDto
   */
  provider?: string;
}
/**
 *
 * @export
 * @interface CreatePersonAddressDto
 */
export interface CreatePersonAddressDto {
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonAddressDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  user_code: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonAddressDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof CreatePersonAddressDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof CreatePersonAddressDto
   */
  latitude?: number;
}
/**
 *
 * @export
 * @interface CreatePersonExtendedDto
 */
export interface CreatePersonExtendedDto {
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonExtendedDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  role: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonExtendedDto
   */
  is_admin?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  password: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonExtendedDto
   */
  is_verified?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  activation_code?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  birthday?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonExtendedDto
   */
  is_blocked?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  father_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  mother_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  sss?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  philhealth?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  pagibig?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  tin?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  medical_condition?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  blood_type?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  elementary?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  high_school?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  college?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  post_college?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  undergraduate?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  curriculum_vitae?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  supporting_doc?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  intent_letter?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonExtendedDto
   */
  application_letter?: string;
  /**
   *
   * @type {CreatePersonAddressDto}
   * @memberof CreatePersonExtendedDto
   */
  address?: CreatePersonAddressDto;
}
/**
 *
 * @export
 * @interface CreateProviderTypeDto
 */
export interface CreateProviderTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateProviderTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateProviderTypeDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface CreateRegistrationDto
 */
export interface CreateRegistrationDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateRegistrationDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  last_name: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  birthday?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateRegistrationDto
   */
  is_taking_medication?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  medication_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateRegistrationDto
   */
  has_allergies?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  allergy_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateRegistrationDto
   */
  has_medical_conditions?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  medical_conditon_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateRegistrationDto
   */
  was_recently_unwell?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  unwell_details?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  other_medical_conditions?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  service?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  other_remarks?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateRegistrationDto
   */
  consent_agreement?: boolean;
  /**
   * PENDING | APPROVE | DECLINE
   * @type {string}
   * @memberof CreateRegistrationDto
   */
  status: string;
}
/**
 *
 * @export
 * @interface CreateRoleDto
 */
export interface CreateRoleDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateRoleDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRoleDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRoleDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateRoleDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoleDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CreateTenantDto
 */
export interface CreateTenantDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateTenantDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTenantDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTenantDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateTenantDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  owner?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  business_name: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  business_type: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  phone_number?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  website: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateTenantDto
   */
  membership_date?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  rewards_type?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTenantDto
   */
  post_registration_link?: string;
}
/**
 *
 * @export
 * @interface CreateUtilServiceDto
 */
export interface CreateUtilServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateUtilServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilServiceDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof CreateUtilServiceDto
   */
  amount: number;
}
/**
 *
 * @export
 * @interface CreateUtilStatusDto
 */
export interface CreateUtilStatusDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateUtilStatusDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateUtilStatusDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface CreateVisitBaseDto
 */
export interface CreateVisitBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateVisitBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  patient: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  contract?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  billing?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  status?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  prescription?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  person?: string;
  /**
   *
   * @type {string}
   * @memberof CreateVisitBaseDto
   */
  avatar?: string;
}
/**
 *
 * @export
 * @interface CreateWaiverDto
 */
export interface CreateWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof CreateWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof CreateWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof CreateWaiverDto
   */
  font_size: number;
  /**
   *
   * @type {string}
   * @memberof CreateWaiverDto
   */
  sub_title?: string;
}
/**
 *
 * @export
 * @interface DashboardControllerDashboard200Response
 */
export interface DashboardControllerDashboard200Response {
  /**
   *
   * @type {string}
   * @memberof DashboardControllerDashboard200Response
   */
  message?: string;
  /**
   *
   * @type {DashboardDto}
   * @memberof DashboardControllerDashboard200Response
   */
  data?: DashboardDto;
}
/**
 *
 * @export
 * @interface DashboardDto
 */
export interface DashboardDto {
  /**
   *
   * @type {number}
   * @memberof DashboardDto
   */
  value?: number;
  /**
   *
   * @type {string}
   * @memberof DashboardDto
   */
  label?: string;
}
/**
 *
 * @export
 * @interface DeleteActivityLogDto
 */
export interface DeleteActivityLogDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteActivityLogDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteActivityLogDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteActivityLogDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteActivityLogDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteActivityLogDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteActivityLogDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteActivityLogDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteActivityLogDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteAttachmentTypeDto
 */
export interface DeleteAttachmentTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteAttachmentTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteAttachmentTypeDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteBillingDto
 */
export interface DeleteBillingDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteBillingDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteBillingDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteBillingDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteBillingDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteBillingDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteBillingDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteBillingDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteBillingDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteConfigDto
 */
export interface DeleteConfigDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteConfigDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteConfigDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteConfigDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteConfigDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteConfigDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteConfigDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteConfigDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteConfigDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteContractDto
 */
export interface DeleteContractDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteContractDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteContractDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteContractDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteContractDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteContractDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteContractDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteContractDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteContractDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteCreditTypeDto
 */
export interface DeleteCreditTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteCreditTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteCreditTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteCreditTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteCreditTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteCreditTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteCreditTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteCreditTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteCreditTypeDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteDebitTypeDto
 */
export interface DeleteDebitTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteDebitTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteDebitTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteDebitTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteDebitTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteDebitTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteDebitTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteDebitTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteDebitTypeDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteItemDto
 */
export interface DeleteItemDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteItemDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteItemDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteItemDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteItemDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteItemDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteItemDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteItemDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteItemDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteLedgerDto
 */
export interface DeleteLedgerDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteLedgerDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteLedgerDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteLedgerDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteLedgerDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteLedgerDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteLedgerDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteLedgerDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteLedgerDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeletePatientDto
 */
export interface DeletePatientDto {
  /**
   *
   * @type {boolean}
   * @memberof DeletePatientDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePatientDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePatientDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePatientDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePatientDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePatientDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePatientDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePatientDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeletePaymentDto
 */
export interface DeletePaymentDto {
  /**
   *
   * @type {boolean}
   * @memberof DeletePaymentDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePaymentDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePaymentDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePaymentDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePaymentDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePaymentDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePaymentDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePaymentDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeletePersonAddressDto
 */
export interface DeletePersonAddressDto {
  /**
   *
   * @type {boolean}
   * @memberof DeletePersonAddressDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonAddressDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeletePersonDto
 */
export interface DeletePersonDto {
  /**
   *
   * @type {boolean}
   * @memberof DeletePersonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeletePersonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeletePersonDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteProviderTypeDto
 */
export interface DeleteProviderTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteProviderTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteProviderTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteProviderTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteProviderTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteProviderTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteProviderTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteProviderTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteProviderTypeDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteRegistrationDto
 */
export interface DeleteRegistrationDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteRegistrationDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRegistrationDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRegistrationDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRegistrationDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRegistrationDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRegistrationDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRegistrationDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRegistrationDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteRoleDto
 */
export interface DeleteRoleDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteRoleDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRoleDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRoleDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRoleDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRoleDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteRoleDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRoleDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteRoleDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteTenantDto
 */
export interface DeleteTenantDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteTenantDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTenantDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTenantDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTenantDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTenantDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteTenantDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTenantDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteTenantDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteUtilServiceDto
 */
export interface DeleteUtilServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteUtilServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteUtilServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteUtilServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteUtilServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteUtilServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteUtilServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteUtilServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteUtilServiceDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteUtilStatusDto
 */
export interface DeleteUtilStatusDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteUtilStatusDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteUtilStatusDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteUtilStatusDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteUtilStatusDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteUtilStatusDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteUtilStatusDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteUtilStatusDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteUtilStatusDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteVisitDto
 */
export interface DeleteVisitDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteVisitDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteVisitDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteVisitDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteVisitDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteVisitDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteVisitDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteVisitDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteVisitDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeleteWaiverDto
 */
export interface DeleteWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof DeleteWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof DeleteWaiverDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface DeviceAuthorization
 */
export interface DeviceAuthorization {
  /**
   *
   * @type {boolean}
   * @memberof DeviceAuthorization
   */
  authorize: boolean;
}
/**
 *
 * @export
 * @interface DeviceRegistrationControllerRegister201Response
 */
export interface DeviceRegistrationControllerRegister201Response {
  /**
   *
   * @type {string}
   * @memberof DeviceRegistrationControllerRegister201Response
   */
  message?: string;
  /**
   *
   * @type {AccessTokenOnlyDto}
   * @memberof DeviceRegistrationControllerRegister201Response
   */
  data?: AccessTokenOnlyDto;
}
/**
 *
 * @export
 * @interface EditActivityLogDto
 */
export interface EditActivityLogDto {
  /**
   *
   * @type {boolean}
   * @memberof EditActivityLogDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditActivityLogDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditActivityLogDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditActivityLogDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  request_code?: string;
  /**
   * describes the database table source
   * @type {string}
   * @memberof EditActivityLogDto
   */
  request_source?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  tenant: string;
  /**
   * CREATE | UPDATE | DELETE
   * @type {string}
   * @memberof EditActivityLogDto
   */
  action: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  old_value?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  new_value?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EditActivityLogDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface EditAttachmentTypeDto
 */
export interface EditAttachmentTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof EditAttachmentTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditAttachmentTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface EditBillingDto
 */
export interface EditBillingDto {
  /**
   *
   * @type {boolean}
   * @memberof EditBillingDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditBillingDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditBillingDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditBillingDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditBillingDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditBillingDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditBillingDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditBillingDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditBillingDto
   */
  contract: string;
  /**
   *
   * @type {number}
   * @memberof EditBillingDto
   */
  session: number;
  /**
   *
   * @type {number}
   * @memberof EditBillingDto
   */
  amount: number;
  /**
   * UNPAID | PENDING | PAID
   * @type {string}
   * @memberof EditBillingDto
   */
  status: string;
}
/**
 *
 * @export
 * @interface EditConfigDto
 */
export interface EditConfigDto {
  /**
   *
   * @type {boolean}
   * @memberof EditConfigDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditConfigDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditConfigDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditConfigDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof EditConfigDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface EditContractBaseDto
 */
export interface EditContractBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof EditContractBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditContractBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditContractBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditContractBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  code?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditContractBaseDto
   */
  is_on_going?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  waiver?: string;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  patient?: string;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  signature?: string;
  /**
   *
   * @type {number}
   * @memberof EditContractBaseDto
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof EditContractBaseDto
   */
  person?: string;
}
/**
 *
 * @export
 * @interface EditCreditTypeDto
 */
export interface EditCreditTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof EditCreditTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EditCreditTypeDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface EditDebitTypeDto
 */
export interface EditDebitTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof EditDebitTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EditDebitTypeDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface EditItemDto
 */
export interface EditItemDto {
  /**
   *
   * @type {boolean}
   * @memberof EditItemDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditItemDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditItemDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditItemDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof EditItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof EditItemDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface EditLedgerDto
 */
export interface EditLedgerDto {
  /**
   *
   * @type {boolean}
   * @memberof EditLedgerDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditLedgerDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditLedgerDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditLedgerDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditLedgerDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditLedgerDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditLedgerDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditLedgerDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditLedgerDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof EditLedgerDto
   */
  type: string;
  /**
   * CREDIT | DEBIT
   * @type {string}
   * @memberof EditLedgerDto
   */
  action: string;
  /**
   *
   * @type {string}
   * @memberof EditLedgerDto
   */
  batch: string;
  /**
   *
   * @type {number}
   * @memberof EditLedgerDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof EditLedgerDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface EditPatientBaseDto
 */
export interface EditPatientBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  last_name: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  birthday?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  mobile_number?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  is_alergic_to_vitamins?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  is_pregnant?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  is_breast_feeding?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  has_past_hospitalization?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  past_hospitalization_reason?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  has_kidney_problem?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  has_cardiac_problem?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  is_hypertensive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  has_liver_problem?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  other_problems?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  is_taking_medication?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  medication_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  has_allergies?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  allergy_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  has_medical_conditions?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  medical_conditon_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPatientBaseDto
   */
  was_recently_unwell?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  unwell_details?: string;
  /**
   *
   * @type {string}
   * @memberof EditPatientBaseDto
   */
  other_medical_conditions?: string;
}
/**
 *
 * @export
 * @interface EditPaymentBaseDto
 */
export interface EditPaymentBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof EditPaymentBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  billing: string;
  /**
   *
   * @type {number}
   * @memberof EditPaymentBaseDto
   */
  amount_paid: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  payment_date: string;
  /**
   * UNPAID | PENDING | PAID
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof EditPaymentBaseDto
   */
  provider?: string;
}
/**
 *
 * @export
 * @interface EditPersonAddressDto
 */
export interface EditPersonAddressDto {
  /**
   *
   * @type {boolean}
   * @memberof EditPersonAddressDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonAddressDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof EditPersonAddressDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof EditPersonAddressDto
   */
  latitude?: number;
}
/**
 *
 * @export
 * @interface EditPersonExtendedDto
 */
export interface EditPersonExtendedDto {
  /**
   *
   * @type {boolean}
   * @memberof EditPersonExtendedDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  code: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPersonExtendedDto
   */
  is_admin?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  password: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPersonExtendedDto
   */
  is_verified?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  activation_code?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  birthday?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditPersonExtendedDto
   */
  is_blocked?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  father_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  mother_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  sss?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  philhealth?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  pagibig?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  tin?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  medical_condition?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  blood_type?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  elementary?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  high_school?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  college?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  post_college?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  undergraduate?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  curriculum_vitae?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  supporting_doc?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  intent_letter?: string;
  /**
   *
   * @type {string}
   * @memberof EditPersonExtendedDto
   */
  application_letter?: string;
  /**
   *
   * @type {EditPersonAddressDto}
   * @memberof EditPersonExtendedDto
   */
  address?: EditPersonAddressDto;
}
/**
 *
 * @export
 * @interface EditProviderTypeDto
 */
export interface EditProviderTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof EditProviderTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EditProviderTypeDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface EditRegistrationDto
 */
export interface EditRegistrationDto {
  /**
   *
   * @type {boolean}
   * @memberof EditRegistrationDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRegistrationDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRegistrationDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRegistrationDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  last_name: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditRegistrationDto
   */
  birthday?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof EditRegistrationDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditRegistrationDto
   */
  is_taking_medication?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  medication_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditRegistrationDto
   */
  has_allergies?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  allergy_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditRegistrationDto
   */
  has_medical_conditions?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  medical_conditon_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditRegistrationDto
   */
  was_recently_unwell?: boolean;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  unwell_details?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  other_medical_conditions?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  service?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditRegistrationDto
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof EditRegistrationDto
   */
  other_remarks?: string;
  /**
   *
   * @type {boolean}
   * @memberof EditRegistrationDto
   */
  consent_agreement?: boolean;
  /**
   * PENDING | APPROVE | DECLINE
   * @type {string}
   * @memberof EditRegistrationDto
   */
  status: string;
}
/**
 *
 * @export
 * @interface EditRoleDto
 */
export interface EditRoleDto {
  /**
   *
   * @type {boolean}
   * @memberof EditRoleDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRoleDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRoleDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditRoleDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditRoleDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface EditTenantDto
 */
export interface EditTenantDto {
  /**
   *
   * @type {boolean}
   * @memberof EditTenantDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTenantDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTenantDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditTenantDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  owner?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  business_name: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  business_type: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  phone_number?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  website: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditTenantDto
   */
  membership_date?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  rewards_type?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof EditTenantDto
   */
  post_registration_link?: string;
}
/**
 *
 * @export
 * @interface EditUtilServiceDto
 */
export interface EditUtilServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof EditUtilServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilServiceDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof EditUtilServiceDto
   */
  amount: number;
}
/**
 *
 * @export
 * @interface EditUtilStatusDto
 */
export interface EditUtilStatusDto {
  /**
   *
   * @type {boolean}
   * @memberof EditUtilStatusDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditUtilStatusDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface EditVisitBaseDto
 */
export interface EditVisitBaseDto {
  /**
   *
   * @type {boolean}
   * @memberof EditVisitBaseDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  patient: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  contract?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  billing?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  status?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  prescription?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  person?: string;
  /**
   *
   * @type {string}
   * @memberof EditVisitBaseDto
   */
  avatar?: string;
}
/**
 *
 * @export
 * @interface EditWaiverDto
 */
export interface EditWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof EditWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EditWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof EditWaiverDto
   */
  font_size: number;
  /**
   *
   * @type {string}
   * @memberof EditWaiverDto
   */
  sub_title?: string;
}
/**
 *
 * @export
 * @interface EndContractDto
 */
export interface EndContractDto {
  /**
   *
   * @type {boolean}
   * @memberof EndContractDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EndContractDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof EndContractDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EndContractDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof EndContractDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof EndContractDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof EndContractDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof EndContractDto
   */
  code: string;
}
/**
 *
 * @export
 * @interface GenericErrorResponseDto
 */
export interface GenericErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof GenericErrorResponseDto
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof GenericErrorResponseDto
   */
  status_code?: number;
}
/**
 *
 * @export
 * @interface GetActivityLogDto
 */
export interface GetActivityLogDto {
  /**
   *
   * @type {boolean}
   * @memberof GetActivityLogDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetActivityLogDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetActivityLogDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetActivityLogDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  request_code?: string;
  /**
   * describes the database table source
   * @type {string}
   * @memberof GetActivityLogDto
   */
  request_source?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  tenant: string;
  /**
   * CREATE | UPDATE | DELETE
   * @type {string}
   * @memberof GetActivityLogDto
   */
  action: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  old_value?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  new_value?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetActivityLogDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface GetAttachmentTypeDto
 */
export interface GetAttachmentTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof GetAttachmentTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentTypeDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface GetAttachmentVisitDto
 */
export interface GetAttachmentVisitDto {
  /**
   *
   * @type {boolean}
   * @memberof GetAttachmentVisitDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  attach_file?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  visit?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  prescription?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  contract?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  signature?: string;
  /**
   *
   * @type {number}
   * @memberof GetAttachmentVisitDto
   */
  contract_amount: number;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  patient: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  patient_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  patient_middle_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  patient_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  birthday: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  mobile_number: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  billing?: string;
  /**
   *
   * @type {number}
   * @memberof GetAttachmentVisitDto
   */
  session: number;
  /**
   *
   * @type {number}
   * @memberof GetAttachmentVisitDto
   */
  billing_amount: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  billing_date: string;
  /**
   * UNPAID | PENDING | PAID
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  status: string;
  /**
   *
   * @type {number}
   * @memberof GetAttachmentVisitDto
   */
  balance: number;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  util_status: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  util_status_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  util_status_description: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  service: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  service_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  service_description: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  person?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  person_first_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  person_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  person_last_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  role_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  role_description?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  tenant_owner: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  tenant_business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  tenant_business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  tenant_description: string;
  /**
   *
   * @type {string}
   * @memberof GetAttachmentVisitDto
   */
  tenant_email: string;
}
/**
 *
 * @export
 * @interface GetBillingDto
 */
export interface GetBillingDto {
  /**
   *
   * @type {boolean}
   * @memberof GetBillingDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetBillingDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetBillingDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetBillingDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  code?: string;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  session: number;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  amount: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetBillingDto
   */
  billing_date: string;
  /**
   * UNPAID | PENDING | PAID
   * @type {string}
   * @memberof GetBillingDto
   */
  status: string;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  balance: number;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  contract: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  signature: string;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  contract_amount: number;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  last_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  service_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  service_description?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  payment?: string;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  amount_paid: number;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  total_amount_paid: number;
  /**
   *
   * @type {number}
   * @memberof GetBillingDto
   */
  total_balance: number;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  provider?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  provider_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  provider_description?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  tenant_owner: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  tenant_business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  tenant_business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  tenant_description: string;
  /**
   *
   * @type {string}
   * @memberof GetBillingDto
   */
  tenant_email: string;
}
/**
 *
 * @export
 * @interface GetConfigDto
 */
export interface GetConfigDto {
  /**
   *
   * @type {boolean}
   * @memberof GetConfigDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetConfigDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof GetConfigDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface GetContractDto
 */
export interface GetContractDto {
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetContractDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetContractDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetContractDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  code?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  is_on_going?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  signature: string;
  /**
   *
   * @type {number}
   * @memberof GetContractDto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof GetContractDto
   */
  total_balance?: number;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  tenant_owner: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  tenant_business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  tenant_business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  tenant_description: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  tenant_email: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  waiver?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  waiver_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  waiver_description?: string;
  /**
   *
   * @type {number}
   * @memberof GetContractDto
   */
  font_size: number;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  waiver_sub_title: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  patient: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  middle_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  birthday: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  mobile_number: string;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  is_alergic_to_vitamins?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  is_pregnant: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  is_breast_feeding: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  has_past_hospitalization: boolean;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  past_hospitalization_reason?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  has_kidney_problem?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  has_cardiac_problem?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  is_hypertensive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetContractDto
   */
  has_liver_problem?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  other_problems?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  service: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  service_name: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  service_description: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  person?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  person_first_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  person_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  person_last_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  role_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetContractDto
   */
  role_description?: string;
}
/**
 *
 * @export
 * @interface GetCreditTypeDto
 */
export interface GetCreditTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof GetCreditTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetCreditTypeDto
   */
  tenant_name?: string;
}
/**
 *
 * @export
 * @interface GetDebitTypeDto
 */
export interface GetDebitTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof GetDebitTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetDebitTypeDto
   */
  tenant_name?: string;
}
/**
 *
 * @export
 * @interface GetItemDto
 */
export interface GetItemDto {
  /**
   *
   * @type {boolean}
   * @memberof GetItemDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetItemDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetItemDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof GetItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof GetItemDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface GetLedgerDto
 */
export interface GetLedgerDto {
  /**
   *
   * @type {boolean}
   * @memberof GetLedgerDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetLedgerDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetLedgerDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetLedgerDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  tenant_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  type_name: string;
  /**
   * CREDIT | DEBIT
   * @type {string}
   * @memberof GetLedgerDto
   */
  action: string;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  batch: string;
  /**
   *
   * @type {number}
   * @memberof GetLedgerDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof GetLedgerDto
   */
  remarks?: string;
}
/**
 *
 * @export
 * @interface GetPatientDto
 */
export interface GetPatientDto {
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPatientDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPatientDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPatientDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  last_name: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetPatientDto
   */
  birthday?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof GetPatientDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  mobile_number?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  is_alergic_to_vitamins?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  is_pregnant?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  is_breast_feeding?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  has_past_hospitalization?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  past_hospitalization_reason?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  has_kidney_problem?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  has_cardiac_problem?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  is_hypertensive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  has_liver_problem?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  other_problems?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  tenant_owner: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  tenant_business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  tenant_business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  tenant_description: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  tenant_email: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  is_taking_medication?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  medication_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  has_allergies?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  allergy_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  has_medical_conditions?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  medical_conditon_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPatientDto
   */
  was_recently_unwell?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  unwell_details?: string;
  /**
   *
   * @type {string}
   * @memberof GetPatientDto
   */
  other_medical_conditions?: string;
}
/**
 *
 * @export
 * @interface GetPaymentDto
 */
export interface GetPaymentDto {
  /**
   *
   * @type {boolean}
   * @memberof GetPaymentDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPaymentDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPaymentDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPaymentDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  code?: string;
  /**
   *
   * @type {number}
   * @memberof GetPaymentDto
   */
  amount_paid: number;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  avatar?: string;
  /**
   *
   * @type {number}
   * @memberof GetPaymentDto
   */
  total_amount_paid: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetPaymentDto
   */
  payment_date: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  billing?: string;
  /**
   *
   * @type {number}
   * @memberof GetPaymentDto
   */
  billing_session: number;
  /**
   *
   * @type {number}
   * @memberof GetPaymentDto
   */
  billing_amount: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetPaymentDto
   */
  billing_date: string;
  /**
   * UNPAID | PENDING | PAID
   * @type {string}
   * @memberof GetPaymentDto
   */
  billing_status: string;
  /**
   *
   * @type {number}
   * @memberof GetPaymentDto
   */
  billing_balance: number;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  contract: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  contract_signature: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  contract_amount: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  patient: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  middle_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  service: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  service_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  service_description: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  provider?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  provider_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  provider_description?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  tenant_owner: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  tenant_business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  tenant_business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  tenant_description: string;
  /**
   *
   * @type {string}
   * @memberof GetPaymentDto
   */
  tenant_email: string;
}
/**
 *
 * @export
 * @interface GetPersonAddressDto
 */
export interface GetPersonAddressDto {
  /**
   *
   * @type {boolean}
   * @memberof GetPersonAddressDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  user_code: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  person_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  person_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  person_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  street_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  subdivision?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  sitio?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  purok?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  barangay?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  municipality?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  country?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonAddressDto
   */
  zip?: string;
  /**
   *
   * @type {number}
   * @memberof GetPersonAddressDto
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof GetPersonAddressDto
   */
  latitude?: number;
}
/**
 *
 * @export
 * @interface GetPersonDto
 */
export interface GetPersonDto {
  /**
   *
   * @type {boolean}
   * @memberof GetPersonDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  business_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  role_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  role_description: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  password: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPersonDto
   */
  is_verified?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  activation_code?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof GetPersonDto
   */
  gender: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetPersonDto
   */
  birthday?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetPersonDto
   */
  is_blocked?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  father_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  mother_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_1_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_1_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_1_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_2_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_2_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  emergency_contact_2_relationship?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  sss?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  philhealth?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  pagibig?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  tin?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  medical_condition?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  blood_type?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  elementary?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  high_school?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  college?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  post_college?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  undergraduate?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  curriculum_vitae?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  supporting_doc?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  intent_letter?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonDto
   */
  application_letter?: string;
  /**
   *
   * @type {number}
   * @memberof GetPersonDto
   */
  total_ongoing_contracts?: number;
  /**
   *
   * @type {number}
   * @memberof GetPersonDto
   */
  total_finished_contracts?: number;
  /**
   *
   * @type {number}
   * @memberof GetPersonDto
   */
  total_patients_handled?: number;
  /**
   *
   * @type {GetPersonAddressDto}
   * @memberof GetPersonDto
   */
  address: GetPersonAddressDto;
}
/**
 *
 * @export
 * @interface GetProviderTypeDto
 */
export interface GetProviderTypeDto {
  /**
   *
   * @type {boolean}
   * @memberof GetProviderTypeDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetProviderTypeDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface GetRegistrationDto
 */
export interface GetRegistrationDto {
  /**
   *
   * @type {boolean}
   * @memberof GetRegistrationDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRegistrationDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRegistrationDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRegistrationDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  last_name: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetRegistrationDto
   */
  birthday?: string;
  /**
   * MALE | FEMALE
   * @type {string}
   * @memberof GetRegistrationDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  tenant_owner: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  tenant_business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  tenant_business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  tenant_description: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  tenant_email: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetRegistrationDto
   */
  is_taking_medication?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  medication_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetRegistrationDto
   */
  has_allergies?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  allergy_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetRegistrationDto
   */
  has_medical_conditions?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  medical_conditon_details?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetRegistrationDto
   */
  was_recently_unwell?: boolean;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  unwell_details?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  other_medical_conditions?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  service_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  service_description?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetRegistrationDto
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegistrationDto
   */
  other_remarks?: string;
  /**
   *
   * @type {boolean}
   * @memberof GetRegistrationDto
   */
  consent_agreement?: boolean;
  /**
   * PENDING | APPROVE | DECLINE
   * @type {string}
   * @memberof GetRegistrationDto
   */
  status: string;
}
/**
 *
 * @export
 * @interface GetRoleDto
 */
export interface GetRoleDto {
  /**
   *
   * @type {boolean}
   * @memberof GetRoleDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRoleDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetRoleDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface GetTenantDto
 */
export interface GetTenantDto {
  /**
   *
   * @type {boolean}
   * @memberof GetTenantDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTenantDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  owner?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  mobile_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  phone_number?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  website: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetTenantDto
   */
  membership_date?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  rewards_type?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof GetTenantDto
   */
  post_registration_link?: string;
}
/**
 *
 * @export
 * @interface GetTenantServiceDto
 */
export interface GetTenantServiceDto {
  /**
   *
   * @type {string}
   * @memberof GetTenantServiceDto
   */
  tenant: string;
}
/**
 *
 * @export
 * @interface GetUtilServiceDto
 */
export interface GetUtilServiceDto {
  /**
   *
   * @type {boolean}
   * @memberof GetUtilServiceDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilServiceDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof GetUtilServiceDto
   */
  amount: number;
}
/**
 *
 * @export
 * @interface GetUtilStatusDto
 */
export interface GetUtilStatusDto {
  /**
   *
   * @type {boolean}
   * @memberof GetUtilStatusDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetUtilStatusDto
   */
  description?: string;
}
/**
 *
 * @export
 * @interface GetVisitDto
 */
export interface GetVisitDto {
  /**
   *
   * @type {boolean}
   * @memberof GetVisitDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetVisitDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetVisitDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetVisitDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  code?: string;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetVisitDto
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  prescription?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  avatar?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  contract?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  signature?: string;
  /**
   *
   * @type {number}
   * @memberof GetVisitDto
   */
  contract_amount: number;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  waiver: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  waiver_name: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  waiver_description: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  patient: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  patient_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  patient_middle_name: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  patient_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  birthday: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  gender: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  mobile_number: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  billing?: string;
  /**
   *
   * @type {number}
   * @memberof GetVisitDto
   */
  session: number;
  /**
   *
   * @type {number}
   * @memberof GetVisitDto
   */
  billing_amount: number;
  /**
   * The date of the event. Format: YYYY-MM-DD
   * @type {string}
   * @memberof GetVisitDto
   */
  billing_date: string;
  /**
   * UNPAID | PENDING | PAID
   * @type {string}
   * @memberof GetVisitDto
   */
  status: string;
  /**
   *
   * @type {number}
   * @memberof GetVisitDto
   */
  balance: number;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  util_status: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  util_status_name: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  util_status_description: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  service: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  service_name: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  service_description: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  person?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  person_first_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  person_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  person_last_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  role_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  role_description?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  tenant_owner: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  tenant_business_name: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  tenant_business_type: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  tenant_description: string;
  /**
   *
   * @type {string}
   * @memberof GetVisitDto
   */
  tenant_email: string;
}
/**
 *
 * @export
 * @interface GetWaiverDto
 */
export interface GetWaiverDto {
  /**
   *
   * @type {boolean}
   * @memberof GetWaiverDto
   */
  is_active?: boolean;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_by?: string;
  /**
   * The date and time of the event. Format: YYYY-MM-DD HH:ii:ss
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_at?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_by?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  created_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  updated_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_first_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_middle_name?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  deleted_last_name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  tenant?: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof GetWaiverDto
   */
  font_size: number;
  /**
   *
   * @type {string}
   * @memberof GetWaiverDto
   */
  sub_title?: string;
}
/**
 *
 * @export
 * @interface LedgerControllerGet200Response
 */
export interface LedgerControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof LedgerControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetLedgerDto>}
   * @memberof LedgerControllerGet200Response
   */
  data?: Array<GetLedgerDto>;
}
/**
 *
 * @export
 * @interface MessageArrayDataResponseDto
 */
export interface MessageArrayDataResponseDto {
  /**
   *
   * @type {string}
   * @memberof MessageArrayDataResponseDto
   */
  message: string;
  /**
   *
   * @type {Array<MessageWithIdentifierDto>}
   * @memberof MessageArrayDataResponseDto
   */
  data: Array<MessageWithIdentifierDto>;
}
/**
 *
 * @export
 * @interface MessageResponseDto
 */
export interface MessageResponseDto {
  /**
   *
   * @type {string}
   * @memberof MessageResponseDto
   */
  message?: string;
  /**
   *
   * @type {object}
   * @memberof MessageResponseDto
   */
  data?: object;
}
/**
 *
 * @export
 * @interface MessageWithIdentifierDto
 */
export interface MessageWithIdentifierDto {
  /**
   *
   * @type {string}
   * @memberof MessageWithIdentifierDto
   */
  identifier: string;
  /**
   *
   * @type {string}
   * @memberof MessageWithIdentifierDto
   */
  message: string;
}
/**
 *
 * @export
 * @interface PatientControllerGet200Response
 */
export interface PatientControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof PatientControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetPatientDto>}
   * @memberof PatientControllerGet200Response
   */
  data?: Array<GetPatientDto>;
}
/**
 *
 * @export
 * @interface PaymentControllerGet200Response
 */
export interface PaymentControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof PaymentControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetPaymentDto>}
   * @memberof PaymentControllerGet200Response
   */
  data?: Array<GetPaymentDto>;
}
/**
 *
 * @export
 * @interface PersonAddressControllerGet200Response
 */
export interface PersonAddressControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof PersonAddressControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetPersonAddressDto>}
   * @memberof PersonAddressControllerGet200Response
   */
  data?: Array<GetPersonAddressDto>;
}
/**
 *
 * @export
 * @interface PersonControllerActivity200Response
 */
export interface PersonControllerActivity200Response {
  /**
   *
   * @type {number}
   * @memberof PersonControllerActivity200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetActivityLogDto>}
   * @memberof PersonControllerActivity200Response
   */
  data?: Array<GetActivityLogDto>;
}
/**
 *
 * @export
 * @interface PersonControllerGet200Response
 */
export interface PersonControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof PersonControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetPersonDto>}
   * @memberof PersonControllerGet200Response
   */
  data?: Array<GetPersonDto>;
}
/**
 *
 * @export
 * @interface RegistrationControllerGet200Response
 */
export interface RegistrationControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof RegistrationControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetRegistrationDto>}
   * @memberof RegistrationControllerGet200Response
   */
  data?: Array<GetRegistrationDto>;
}
/**
 *
 * @export
 * @interface RenewRefreshTokenDto
 */
export interface RenewRefreshTokenDto {
  /**
   *
   * @type {string}
   * @memberof RenewRefreshTokenDto
   */
  user_code?: string;
  /**
   *
   * @type {string}
   * @memberof RenewRefreshTokenDto
   */
  refresh_token?: string;
  /**
   *
   * @type {number}
   * @memberof RenewRefreshTokenDto
   */
  refresh_exp?: number;
}
/**
 *
 * @export
 * @interface SigninUserRequestDto
 */
export interface SigninUserRequestDto {
  /**
   *
   * @type {string}
   * @memberof SigninUserRequestDto
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof SigninUserRequestDto
   */
  password: string;
}
/**
 *
 * @export
 * @interface SwaggerExceptionResponseDto
 */
export interface SwaggerExceptionResponseDto {
  /**
   *
   * @type {string}
   * @memberof SwaggerExceptionResponseDto
   */
  message: string;
}
/**
 *
 * @export
 * @interface TenantControllerGet200Response
 */
export interface TenantControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof TenantControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetTenantDto>}
   * @memberof TenantControllerGet200Response
   */
  data?: Array<GetTenantDto>;
}
/**
 *
 * @export
 * @interface TokenDto
 */
export interface TokenDto {
  /**
   *
   * @type {string}
   * @memberof TokenDto
   */
  access_token?: string;
  /**
   *
   * @type {string}
   * @memberof TokenDto
   */
  refresh_token?: string;
  /**
   *
   * @type {string}
   * @memberof TokenDto
   */
  user_code?: string;
  /**
   *
   * @type {TokenRoleResponseDto}
   * @memberof TokenDto
   */
  role?: TokenRoleResponseDto;
  /**
   *
   * @type {number}
   * @memberof TokenDto
   */
  access_exp?: number;
  /**
   *
   * @type {number}
   * @memberof TokenDto
   */
  refresh_exp?: number;
}
/**
 *
 * @export
 * @interface TokenRoleResponseDto
 */
export interface TokenRoleResponseDto {
  /**
   *
   * @type {string}
   * @memberof TokenRoleResponseDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof TokenRoleResponseDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof TokenRoleResponseDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof TokenRoleResponseDto
   */
  tenant?: string;
}
/**
 *
 * @export
 * @interface UtilAttachmentTypeControllerGet200Response
 */
export interface UtilAttachmentTypeControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilAttachmentTypeControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetAttachmentTypeDto>}
   * @memberof UtilAttachmentTypeControllerGet200Response
   */
  data?: Array<GetAttachmentTypeDto>;
}
/**
 *
 * @export
 * @interface UtilConfigControllerGet200Response
 */
export interface UtilConfigControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilConfigControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetConfigDto>}
   * @memberof UtilConfigControllerGet200Response
   */
  data?: Array<GetConfigDto>;
}
/**
 *
 * @export
 * @interface UtilCreditTypeControllerGet200Response
 */
export interface UtilCreditTypeControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilCreditTypeControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetCreditTypeDto>}
   * @memberof UtilCreditTypeControllerGet200Response
   */
  data?: Array<GetCreditTypeDto>;
}
/**
 *
 * @export
 * @interface UtilDebitTypeControllerGet200Response
 */
export interface UtilDebitTypeControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilDebitTypeControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetDebitTypeDto>}
   * @memberof UtilDebitTypeControllerGet200Response
   */
  data?: Array<GetDebitTypeDto>;
}
/**
 *
 * @export
 * @interface UtilItemControllerGet200Response
 */
export interface UtilItemControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilItemControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetItemDto>}
   * @memberof UtilItemControllerGet200Response
   */
  data?: Array<GetItemDto>;
}
/**
 *
 * @export
 * @interface UtilProviderTypeControllerGet200Response
 */
export interface UtilProviderTypeControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilProviderTypeControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetProviderTypeDto>}
   * @memberof UtilProviderTypeControllerGet200Response
   */
  data?: Array<GetProviderTypeDto>;
}
/**
 *
 * @export
 * @interface UtilRoleControllerGet200Response
 */
export interface UtilRoleControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilRoleControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetRoleDto>}
   * @memberof UtilRoleControllerGet200Response
   */
  data?: Array<GetRoleDto>;
}
/**
 *
 * @export
 * @interface UtilServiceControllerGet200Response
 */
export interface UtilServiceControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilServiceControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetUtilServiceDto>}
   * @memberof UtilServiceControllerGet200Response
   */
  data?: Array<GetUtilServiceDto>;
}
/**
 *
 * @export
 * @interface UtilStatusControllerGet200Response
 */
export interface UtilStatusControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof UtilStatusControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetUtilStatusDto>}
   * @memberof UtilStatusControllerGet200Response
   */
  data?: Array<GetUtilStatusDto>;
}
/**
 *
 * @export
 * @interface VisitControllerGet200Response
 */
export interface VisitControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof VisitControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetVisitDto>}
   * @memberof VisitControllerGet200Response
   */
  data?: Array<GetVisitDto>;
}
/**
 *
 * @export
 * @interface VisitControllerGetAttachment200Response
 */
export interface VisitControllerGetAttachment200Response {
  /**
   *
   * @type {number}
   * @memberof VisitControllerGetAttachment200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetAttachmentVisitDto>}
   * @memberof VisitControllerGetAttachment200Response
   */
  data?: Array<GetAttachmentVisitDto>;
}
/**
 *
 * @export
 * @interface WaiverControllerGet200Response
 */
export interface WaiverControllerGet200Response {
  /**
   *
   * @type {number}
   * @memberof WaiverControllerGet200Response
   */
  count?: number;
  /**
   *
   * @type {Array<GetWaiverDto>}
   * @memberof WaiverControllerGet200Response
   */
  data?: Array<GetWaiverDto>;
}

/**
 * ActivityLogApi - axios parameter creator
 * @export
 */
export const ActivityLogApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateActivityLogDto} createActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activityLogControllerCreate: async (
      createActivityLogDto: CreateActivityLogDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createActivityLogDto' is not null or undefined
      assertParamExists(
        "activityLogControllerCreate",
        "createActivityLogDto",
        createActivityLogDto
      );
      const localVarPath = `/api/v1/activity-log/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createActivityLogDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteActivityLogDto} deleteActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activityLogControllerDelete: async (
      deleteActivityLogDto: DeleteActivityLogDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteActivityLogDto' is not null or undefined
      assertParamExists(
        "activityLogControllerDelete",
        "deleteActivityLogDto",
        deleteActivityLogDto
      );
      const localVarPath = `/api/v1/activity-log/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteActivityLogDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditActivityLogDto} editActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activityLogControllerEdit: async (
      editActivityLogDto: EditActivityLogDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editActivityLogDto' is not null or undefined
      assertParamExists(
        "activityLogControllerEdit",
        "editActivityLogDto",
        editActivityLogDto
      );
      const localVarPath = `/api/v1/activity-log/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editActivityLogDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activityLogControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/activity-log/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ActivityLogApi - functional programming interface
 * @export
 */
export const ActivityLogApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ActivityLogApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateActivityLogDto} createActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activityLogControllerCreate(
      createActivityLogDto: CreateActivityLogDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activityLogControllerCreate(
          createActivityLogDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ActivityLogApi.activityLogControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteActivityLogDto} deleteActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activityLogControllerDelete(
      deleteActivityLogDto: DeleteActivityLogDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activityLogControllerDelete(
          deleteActivityLogDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ActivityLogApi.activityLogControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditActivityLogDto} editActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activityLogControllerEdit(
      editActivityLogDto: EditActivityLogDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activityLogControllerEdit(
          editActivityLogDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ActivityLogApi.activityLogControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activityLogControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activityLogControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ActivityLogApi.activityLogControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ActivityLogApi - factory interface
 * @export
 */
export const ActivityLogApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ActivityLogApiFp(configuration);
  return {
    /**
     *
     * @param {CreateActivityLogDto} createActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activityLogControllerCreate(
      createActivityLogDto: CreateActivityLogDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .activityLogControllerCreate(createActivityLogDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteActivityLogDto} deleteActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activityLogControllerDelete(
      deleteActivityLogDto: DeleteActivityLogDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .activityLogControllerDelete(deleteActivityLogDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditActivityLogDto} editActivityLogDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activityLogControllerEdit(
      editActivityLogDto: EditActivityLogDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .activityLogControllerEdit(editActivityLogDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activityLogControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .activityLogControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ActivityLogApi - object-oriented interface
 * @export
 * @class ActivityLogApi
 * @extends {BaseAPI}
 */
export class ActivityLogApi extends BaseAPI {
  /**
   *
   * @param {CreateActivityLogDto} createActivityLogDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActivityLogApi
   */
  public activityLogControllerCreate(
    createActivityLogDto: CreateActivityLogDto,
    options?: RawAxiosRequestConfig
  ) {
    return ActivityLogApiFp(this.configuration)
      .activityLogControllerCreate(createActivityLogDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteActivityLogDto} deleteActivityLogDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActivityLogApi
   */
  public activityLogControllerDelete(
    deleteActivityLogDto: DeleteActivityLogDto,
    options?: RawAxiosRequestConfig
  ) {
    return ActivityLogApiFp(this.configuration)
      .activityLogControllerDelete(deleteActivityLogDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditActivityLogDto} editActivityLogDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActivityLogApi
   */
  public activityLogControllerEdit(
    editActivityLogDto: EditActivityLogDto,
    options?: RawAxiosRequestConfig
  ) {
    return ActivityLogApiFp(this.configuration)
      .activityLogControllerEdit(editActivityLogDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActivityLogApi
   */
  public activityLogControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ActivityLogApiFp(this.configuration)
      .activityLogControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {SigninUserRequestDto} signinUserRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerAuthenticate: async (
      signinUserRequestDto: SigninUserRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'signinUserRequestDto' is not null or undefined
      assertParamExists(
        "authenticationControllerAuthenticate",
        "signinUserRequestDto",
        signinUserRequestDto
      );
      const localVarPath = `/api/v1/authentication/signin`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        signinUserRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerIntrospect: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/authentication/instrospect`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerRefresh: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/authentication/refresh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerRefreshRenew: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/authentication/refresh/renew`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AuthenticationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {SigninUserRequestDto} signinUserRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authenticationControllerAuthenticate(
      signinUserRequestDto: SigninUserRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthenticationControllerAuthenticate201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authenticationControllerAuthenticate(
          signinUserRequestDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "AuthenticationApi.authenticationControllerAuthenticate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authenticationControllerIntrospect(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authenticationControllerIntrospect(
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "AuthenticationApi.authenticationControllerIntrospect"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authenticationControllerRefresh(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthenticationControllerAuthenticate201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authenticationControllerRefresh(
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "AuthenticationApi.authenticationControllerRefresh"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authenticationControllerRefreshRenew(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthenticationControllerRefreshRenew201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authenticationControllerRefreshRenew(
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "AuthenticationApi.authenticationControllerRefreshRenew"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthenticationApiFp(configuration);
  return {
    /**
     *
     * @param {SigninUserRequestDto} signinUserRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerAuthenticate(
      signinUserRequestDto: SigninUserRequestDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AuthenticationControllerAuthenticate201Response> {
      return localVarFp
        .authenticationControllerAuthenticate(signinUserRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerIntrospect(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .authenticationControllerIntrospect(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerRefresh(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AuthenticationControllerAuthenticate201Response> {
      return localVarFp
        .authenticationControllerRefresh(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticationControllerRefreshRenew(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AuthenticationControllerRefreshRenew201Response> {
      return localVarFp
        .authenticationControllerRefreshRenew(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
  /**
   *
   * @param {SigninUserRequestDto} signinUserRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authenticationControllerAuthenticate(
    signinUserRequestDto: SigninUserRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authenticationControllerAuthenticate(signinUserRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authenticationControllerIntrospect(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authenticationControllerIntrospect(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authenticationControllerRefresh(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authenticationControllerRefresh(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authenticationControllerRefreshRenew(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authenticationControllerRefreshRenew(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/billing/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateBillingDto} createBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerCreate: async (
      createBillingDto: CreateBillingDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createBillingDto' is not null or undefined
      assertParamExists(
        "billingControllerCreate",
        "createBillingDto",
        createBillingDto
      );
      const localVarPath = `/api/v1/billing/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBillingDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteBillingDto} deleteBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerDelete: async (
      deleteBillingDto: DeleteBillingDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteBillingDto' is not null or undefined
      assertParamExists(
        "billingControllerDelete",
        "deleteBillingDto",
        deleteBillingDto
      );
      const localVarPath = `/api/v1/billing/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteBillingDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditBillingDto} editBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerEdit: async (
      editBillingDto: EditBillingDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editBillingDto' is not null or undefined
      assertParamExists(
        "billingControllerEdit",
        "editBillingDto",
        editBillingDto
      );
      const localVarPath = `/api/v1/billing/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editBillingDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/billing/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.billingControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["BillingApi.billingControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateBillingDto} createBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingControllerCreate(
      createBillingDto: CreateBillingDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.billingControllerCreate(
          createBillingDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["BillingApi.billingControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteBillingDto} deleteBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingControllerDelete(
      deleteBillingDto: DeleteBillingDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.billingControllerDelete(
          deleteBillingDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["BillingApi.billingControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditBillingDto} editBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingControllerEdit(
      editBillingDto: EditBillingDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.billingControllerEdit(
          editBillingDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["BillingApi.billingControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async billingControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<BillingControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.billingControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["BillingApi.billingControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BillingApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .billingControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateBillingDto} createBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerCreate(
      createBillingDto: CreateBillingDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .billingControllerCreate(createBillingDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteBillingDto} deleteBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerDelete(
      deleteBillingDto: DeleteBillingDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .billingControllerDelete(deleteBillingDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditBillingDto} editBillingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerEdit(
      editBillingDto: EditBillingDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .billingControllerEdit(editBillingDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    billingControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BillingControllerGet200Response> {
      return localVarFp
        .billingControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateBillingDto} createBillingDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingControllerCreate(
    createBillingDto: CreateBillingDto,
    options?: RawAxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingControllerCreate(createBillingDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteBillingDto} deleteBillingDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingControllerDelete(
    deleteBillingDto: DeleteBillingDto,
    options?: RawAxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingControllerDelete(deleteBillingDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditBillingDto} editBillingDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingControllerEdit(
    editBillingDto: EditBillingDto,
    options?: RawAxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingControllerEdit(editBillingDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */
  public billingControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return BillingApiFp(this.configuration)
      .billingControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ContractApi - axios parameter creator
 * @export
 */
export const ContractApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/contract/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateContractBaseDto} contract
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerCreate: async (
      contract: CreateContractBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contract' is not null or undefined
      assertParamExists("contractControllerCreate", "contract", contract);
      const localVarPath = `/api/v1/contract/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (contract !== undefined) {
        localVarFormParams.append("contract", JSON.stringify(contract));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteContractDto} deleteContractDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerDelete: async (
      deleteContractDto: DeleteContractDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteContractDto' is not null or undefined
      assertParamExists(
        "contractControllerDelete",
        "deleteContractDto",
        deleteContractDto
      );
      const localVarPath = `/api/v1/contract/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteContractDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditContractBaseDto} contract
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerEdit: async (
      contract: EditContractBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contract' is not null or undefined
      assertParamExists("contractControllerEdit", "contract", contract);
      const localVarPath = `/api/v1/contract/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (contract !== undefined) {
        localVarFormParams.append("contract", JSON.stringify(contract));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EndContractDto} endContractDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerEnd: async (
      endContractDto: EndContractDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'endContractDto' is not null or undefined
      assertParamExists(
        "contractControllerEnd",
        "endContractDto",
        endContractDto
      );
      const localVarPath = `/api/v1/contract/end`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endContractDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/contract/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContractApi - functional programming interface
 * @export
 */
export const ContractApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ContractApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ContractApi.contractControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateContractBaseDto} contract
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractControllerCreate(
      contract: CreateContractBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractControllerCreate(
          contract,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ContractApi.contractControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteContractDto} deleteContractDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractControllerDelete(
      deleteContractDto: DeleteContractDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractControllerDelete(
          deleteContractDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ContractApi.contractControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditContractBaseDto} contract
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractControllerEdit(
      contract: EditContractBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractControllerEdit(
          contract,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ContractApi.contractControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EndContractDto} endContractDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractControllerEnd(
      endContractDto: EndContractDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractControllerEnd(
          endContractDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ContractApi.contractControllerEnd"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ContractControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ContractApi.contractControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ContractApi - factory interface
 * @export
 */
export const ContractApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContractApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .contractControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateContractBaseDto} contract
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerCreate(
      contract: CreateContractBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .contractControllerCreate(contract, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteContractDto} deleteContractDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerDelete(
      deleteContractDto: DeleteContractDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .contractControllerDelete(deleteContractDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditContractBaseDto} contract
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerEdit(
      contract: EditContractBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .contractControllerEdit(contract, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EndContractDto} endContractDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerEnd(
      endContractDto: EndContractDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .contractControllerEnd(endContractDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ContractControllerGet200Response> {
      return localVarFp
        .contractControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ContractApi - object-oriented interface
 * @export
 * @class ContractApi
 * @extends {BaseAPI}
 */
export class ContractApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public contractControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .contractControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateContractBaseDto} contract
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public contractControllerCreate(
    contract: CreateContractBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .contractControllerCreate(contract, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteContractDto} deleteContractDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public contractControllerDelete(
    deleteContractDto: DeleteContractDto,
    options?: RawAxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .contractControllerDelete(deleteContractDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditContractBaseDto} contract
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public contractControllerEdit(
    contract: EditContractBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .contractControllerEdit(contract, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EndContractDto} endContractDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public contractControllerEnd(
    endContractDto: EndContractDto,
    options?: RawAxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .contractControllerEnd(endContractDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContractApi
   */
  public contractControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ContractApiFp(this.configuration)
      .contractControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardControllerDashboard: async (
      search?: string,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/dashboard/dashboard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        localVarQueryParameter["start_date"] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter["end_date"] = endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    DashboardApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardControllerDashboard(
      search?: string,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DashboardControllerDashboard200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.dashboardControllerDashboard(
          search,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DashboardApi.dashboardControllerDashboard"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DashboardApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardControllerDashboard(
      search?: string,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<DashboardControllerDashboard200Response> {
      return localVarFp
        .dashboardControllerDashboard(
          search,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardApi
   */
  public dashboardControllerDashboard(
    search?: string,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return DashboardApiFp(this.configuration)
      .dashboardControllerDashboard(
        search,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DeviceAuthorizationApi - axios parameter creator
 * @export
 */
export const DeviceAuthorizationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {DeviceAuthorization} deviceAuthorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deviceRegistrationControllerRegister: async (
      deviceAuthorization: DeviceAuthorization,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceAuthorization' is not null or undefined
      assertParamExists(
        "deviceRegistrationControllerRegister",
        "deviceAuthorization",
        deviceAuthorization
      );
      const localVarPath = `/device/authorization/register`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deviceAuthorization,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DeviceAuthorizationApi - functional programming interface
 * @export
 */
export const DeviceAuthorizationApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    DeviceAuthorizationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {DeviceAuthorization} deviceAuthorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deviceRegistrationControllerRegister(
      deviceAuthorization: DeviceAuthorization,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DeviceRegistrationControllerRegister201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deviceRegistrationControllerRegister(
          deviceAuthorization,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DeviceAuthorizationApi.deviceRegistrationControllerRegister"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DeviceAuthorizationApi - factory interface
 * @export
 */
export const DeviceAuthorizationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DeviceAuthorizationApiFp(configuration);
  return {
    /**
     *
     * @param {DeviceAuthorization} deviceAuthorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deviceRegistrationControllerRegister(
      deviceAuthorization: DeviceAuthorization,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<DeviceRegistrationControllerRegister201Response> {
      return localVarFp
        .deviceRegistrationControllerRegister(deviceAuthorization, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DeviceAuthorizationApi - object-oriented interface
 * @export
 * @class DeviceAuthorizationApi
 * @extends {BaseAPI}
 */
export class DeviceAuthorizationApi extends BaseAPI {
  /**
   *
   * @param {DeviceAuthorization} deviceAuthorization
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeviceAuthorizationApi
   */
  public deviceRegistrationControllerRegister(
    deviceAuthorization: DeviceAuthorization,
    options?: RawAxiosRequestConfig
  ) {
    return DeviceAuthorizationApiFp(this.configuration)
      .deviceRegistrationControllerRegister(deviceAuthorization, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * GoogleCloudStorageApi - axios parameter creator
 * @export
 */
export const GoogleCloudStorageApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} filepath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerGetImage: async (
      filepath: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filepath' is not null or undefined
      assertParamExists("cloudStorageControllerGetImage", "filepath", filepath);
      const localVarPath = `/api/v1/cloud/storage/asset/{filepath}`.replace(
        `{${"filepath"}}`,
        encodeURIComponent(String(filepath))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerGetSampleAssets: async (
      params: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'params' is not null or undefined
      assertParamExists(
        "cloudStorageControllerGetSampleAssets",
        "params",
        params
      );
      const localVarPath = `/api/v1/cloud/storage/sample/{params}`.replace(
        `{${"params"}}`,
        encodeURIComponent(String(params))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerUploadMedia: async (
      file: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists("cloudStorageControllerUploadMedia", "file", file);
      const localVarPath = `/api/v1/cloud/storage/upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GoogleCloudStorageApi - functional programming interface
 * @export
 */
export const GoogleCloudStorageApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    GoogleCloudStorageApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} filepath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cloudStorageControllerGetImage(
      filepath: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cloudStorageControllerGetImage(
          filepath,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "GoogleCloudStorageApi.cloudStorageControllerGetImage"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cloudStorageControllerGetSampleAssets(
      params: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cloudStorageControllerGetSampleAssets(
          params,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "GoogleCloudStorageApi.cloudStorageControllerGetSampleAssets"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cloudStorageControllerUploadMedia(
      file: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cloudStorageControllerUploadMedia(
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "GoogleCloudStorageApi.cloudStorageControllerUploadMedia"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * GoogleCloudStorageApi - factory interface
 * @export
 */
export const GoogleCloudStorageApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = GoogleCloudStorageApiFp(configuration);
  return {
    /**
     *
     * @param {string} filepath
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerGetImage(
      filepath: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<File> {
      return localVarFp
        .cloudStorageControllerGetImage(filepath, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} params
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerGetSampleAssets(
      params: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .cloudStorageControllerGetSampleAssets(params, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cloudStorageControllerUploadMedia(
      file: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .cloudStorageControllerUploadMedia(file, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * GoogleCloudStorageApi - object-oriented interface
 * @export
 * @class GoogleCloudStorageApi
 * @extends {BaseAPI}
 */
export class GoogleCloudStorageApi extends BaseAPI {
  /**
   *
   * @param {string} filepath
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GoogleCloudStorageApi
   */
  public cloudStorageControllerGetImage(
    filepath: string,
    options?: RawAxiosRequestConfig
  ) {
    return GoogleCloudStorageApiFp(this.configuration)
      .cloudStorageControllerGetImage(filepath, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} params
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GoogleCloudStorageApi
   */
  public cloudStorageControllerGetSampleAssets(
    params: string,
    options?: RawAxiosRequestConfig
  ) {
    return GoogleCloudStorageApiFp(this.configuration)
      .cloudStorageControllerGetSampleAssets(params, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GoogleCloudStorageApi
   */
  public cloudStorageControllerUploadMedia(
    file: File,
    options?: RawAxiosRequestConfig
  ) {
    return GoogleCloudStorageApiFp(this.configuration)
      .cloudStorageControllerUploadMedia(file, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * LedgerApi - axios parameter creator
 * @export
 */
export const LedgerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/ledger/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateLedgerDto} createLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerCreate: async (
      createLedgerDto: CreateLedgerDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createLedgerDto' is not null or undefined
      assertParamExists(
        "ledgerControllerCreate",
        "createLedgerDto",
        createLedgerDto
      );
      const localVarPath = `/api/v1/ledger/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createLedgerDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteLedgerDto} deleteLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerDelete: async (
      deleteLedgerDto: DeleteLedgerDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteLedgerDto' is not null or undefined
      assertParamExists(
        "ledgerControllerDelete",
        "deleteLedgerDto",
        deleteLedgerDto
      );
      const localVarPath = `/api/v1/ledger/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteLedgerDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditLedgerDto} editLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerEdit: async (
      editLedgerDto: EditLedgerDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editLedgerDto' is not null or undefined
      assertParamExists("ledgerControllerEdit", "editLedgerDto", editLedgerDto);
      const localVarPath = `/api/v1/ledger/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editLedgerDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/ledger/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LedgerApi - functional programming interface
 * @export
 */
export const LedgerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LedgerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ledgerControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.ledgerControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["LedgerApi.ledgerControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateLedgerDto} createLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ledgerControllerCreate(
      createLedgerDto: CreateLedgerDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.ledgerControllerCreate(
          createLedgerDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["LedgerApi.ledgerControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteLedgerDto} deleteLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ledgerControllerDelete(
      deleteLedgerDto: DeleteLedgerDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.ledgerControllerDelete(
          deleteLedgerDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["LedgerApi.ledgerControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditLedgerDto} editLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ledgerControllerEdit(
      editLedgerDto: EditLedgerDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.ledgerControllerEdit(
          editLedgerDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["LedgerApi.ledgerControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ledgerControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<LedgerControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.ledgerControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["LedgerApi.ledgerControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * LedgerApi - factory interface
 * @export
 */
export const LedgerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = LedgerApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .ledgerControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateLedgerDto} createLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerCreate(
      createLedgerDto: CreateLedgerDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .ledgerControllerCreate(createLedgerDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteLedgerDto} deleteLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerDelete(
      deleteLedgerDto: DeleteLedgerDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .ledgerControllerDelete(deleteLedgerDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditLedgerDto} editLedgerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerEdit(
      editLedgerDto: EditLedgerDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .ledgerControllerEdit(editLedgerDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ledgerControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LedgerControllerGet200Response> {
      return localVarFp
        .ledgerControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * LedgerApi - object-oriented interface
 * @export
 * @class LedgerApi
 * @extends {BaseAPI}
 */
export class LedgerApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LedgerApi
   */
  public ledgerControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return LedgerApiFp(this.configuration)
      .ledgerControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateLedgerDto} createLedgerDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LedgerApi
   */
  public ledgerControllerCreate(
    createLedgerDto: CreateLedgerDto,
    options?: RawAxiosRequestConfig
  ) {
    return LedgerApiFp(this.configuration)
      .ledgerControllerCreate(createLedgerDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteLedgerDto} deleteLedgerDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LedgerApi
   */
  public ledgerControllerDelete(
    deleteLedgerDto: DeleteLedgerDto,
    options?: RawAxiosRequestConfig
  ) {
    return LedgerApiFp(this.configuration)
      .ledgerControllerDelete(deleteLedgerDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditLedgerDto} editLedgerDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LedgerApi
   */
  public ledgerControllerEdit(
    editLedgerDto: EditLedgerDto,
    options?: RawAxiosRequestConfig
  ) {
    return LedgerApiFp(this.configuration)
      .ledgerControllerEdit(editLedgerDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LedgerApi
   */
  public ledgerControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return LedgerApiFp(this.configuration)
      .ledgerControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PatientApi - axios parameter creator
 * @export
 */
export const PatientApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/patient/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePatientBaseDto} patient
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerCreate: async (
      patient: CreatePatientBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'patient' is not null or undefined
      assertParamExists("patientControllerCreate", "patient", patient);
      const localVarPath = `/api/v1/patient/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (patient !== undefined) {
        localVarFormParams.append("patient", JSON.stringify(patient));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePatientDto} deletePatientDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerDelete: async (
      deletePatientDto: DeletePatientDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePatientDto' is not null or undefined
      assertParamExists(
        "patientControllerDelete",
        "deletePatientDto",
        deletePatientDto
      );
      const localVarPath = `/api/v1/patient/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePatientDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditPatientBaseDto} patient
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerEdit: async (
      patient: EditPatientBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'patient' is not null or undefined
      assertParamExists("patientControllerEdit", "patient", patient);
      const localVarPath = `/api/v1/patient/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (patient !== undefined) {
        localVarFormParams.append("patient", JSON.stringify(patient));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/patient/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PatientApi - functional programming interface
 * @export
 */
export const PatientApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PatientApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patientControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PatientApi.patientControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePatientBaseDto} patient
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerCreate(
      patient: CreatePatientBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patientControllerCreate(
          patient,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PatientApi.patientControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePatientDto} deletePatientDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerDelete(
      deletePatientDto: DeletePatientDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patientControllerDelete(
          deletePatientDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PatientApi.patientControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditPatientBaseDto} patient
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerEdit(
      patient: EditPatientBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patientControllerEdit(
          patient,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PatientApi.patientControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patientControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PatientControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patientControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PatientApi.patientControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PatientApi - factory interface
 * @export
 */
export const PatientApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PatientApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .patientControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePatientBaseDto} patient
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerCreate(
      patient: CreatePatientBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .patientControllerCreate(patient, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePatientDto} deletePatientDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerDelete(
      deletePatientDto: DeletePatientDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .patientControllerDelete(deletePatientDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditPatientBaseDto} patient
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerEdit(
      patient: EditPatientBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .patientControllerEdit(patient, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patientControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PatientControllerGet200Response> {
      return localVarFp
        .patientControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PatientApi - object-oriented interface
 * @export
 * @class PatientApi
 * @extends {BaseAPI}
 */
export class PatientApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientApi
   */
  public patientControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PatientApiFp(this.configuration)
      .patientControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePatientBaseDto} patient
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientApi
   */
  public patientControllerCreate(
    patient: CreatePatientBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PatientApiFp(this.configuration)
      .patientControllerCreate(patient, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePatientDto} deletePatientDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientApi
   */
  public patientControllerDelete(
    deletePatientDto: DeletePatientDto,
    options?: RawAxiosRequestConfig
  ) {
    return PatientApiFp(this.configuration)
      .patientControllerDelete(deletePatientDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditPatientBaseDto} patient
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientApi
   */
  public patientControllerEdit(
    patient: EditPatientBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PatientApiFp(this.configuration)
      .patientControllerEdit(patient, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PatientApi
   */
  public patientControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PatientApiFp(this.configuration)
      .patientControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/payment/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePaymentBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerCreate: async (
      payment: CreatePaymentBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'payment' is not null or undefined
      assertParamExists("paymentControllerCreate", "payment", payment);
      const localVarPath = `/api/v1/payment/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (payment !== undefined) {
        localVarFormParams.append("payment", JSON.stringify(payment));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerDelete: async (
      deletePaymentDto: DeletePaymentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePaymentDto' is not null or undefined
      assertParamExists(
        "paymentControllerDelete",
        "deletePaymentDto",
        deletePaymentDto
      );
      const localVarPath = `/api/v1/payment/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePaymentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditPaymentBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerEdit: async (
      payment: EditPaymentBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'payment' is not null or undefined
      assertParamExists("paymentControllerEdit", "payment", payment);
      const localVarPath = `/api/v1/payment/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (payment !== undefined) {
        localVarFormParams.append("payment", JSON.stringify(payment));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/payment/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePaymentBulkBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerPayBulk: async (
      payment: CreatePaymentBulkBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'payment' is not null or undefined
      assertParamExists("paymentControllerPayBulk", "payment", payment);
      const localVarPath = `/api/v1/payment/bulk-payment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (payment !== undefined) {
        localVarFormParams.append("payment", JSON.stringify(payment));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePaymentBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerCreate(
      payment: CreatePaymentBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerCreate(
          payment,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerDelete(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerDelete(
          deletePaymentDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditPaymentBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerEdit(
      payment: EditPaymentBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerEdit(
          payment,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaymentControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePaymentBulkBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentControllerPayBulk(
      payment: CreatePaymentBulkBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.paymentControllerPayBulk(
          payment,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentControllerPayBulk"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PaymentApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .paymentControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePaymentBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerCreate(
      payment: CreatePaymentBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerCreate(payment, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePaymentDto} deletePaymentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerDelete(
      deletePaymentDto: DeletePaymentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerDelete(deletePaymentDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditPaymentBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerEdit(
      payment: EditPaymentBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerEdit(payment, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaymentControllerGet200Response> {
      return localVarFp
        .paymentControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePaymentBulkBaseDto} payment
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentControllerPayBulk(
      payment: CreatePaymentBulkBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .paymentControllerPayBulk(payment, file, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePaymentBaseDto} payment
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerCreate(
    payment: CreatePaymentBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerCreate(payment, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePaymentDto} deletePaymentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerDelete(
    deletePaymentDto: DeletePaymentDto,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerDelete(deletePaymentDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditPaymentBaseDto} payment
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerEdit(
    payment: EditPaymentBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerEdit(payment, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePaymentBulkBaseDto} payment
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public paymentControllerPayBulk(
    payment: CreatePaymentBulkBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PaymentApiFp(this.configuration)
      .paymentControllerPayBulk(payment, file, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PersonApi - axios parameter creator
 * @export
 */
export const PersonApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/person/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerAttachFile: async (
      code: string,
      attachmentType: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("personControllerAttachFile", "code", code);
      // verify required parameter 'attachmentType' is not null or undefined
      assertParamExists(
        "personControllerAttachFile",
        "attachmentType",
        attachmentType
      );
      const localVarPath = `/api/v1/person/attach-file`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (code !== undefined) {
        localVarFormParams.append("code", code as any);
      }

      if (attachmentType !== undefined) {
        localVarFormParams.append("attachment_type", attachmentType as any);
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BlockPersonDto} blockPersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerBlock: async (
      blockPersonDto: BlockPersonDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'blockPersonDto' is not null or undefined
      assertParamExists(
        "personControllerBlock",
        "blockPersonDto",
        blockPersonDto
      );
      const localVarPath = `/api/v1/person/block`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        blockPersonDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerCreate: async (
      person: CreatePersonExtendedDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'person' is not null or undefined
      assertParamExists("personControllerCreate", "person", person);
      const localVarPath = `/api/v1/person/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (person !== undefined) {
        localVarFormParams.append("person", JSON.stringify(person));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePersonDto} deletePersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerDelete: async (
      deletePersonDto: DeletePersonDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePersonDto' is not null or undefined
      assertParamExists(
        "personControllerDelete",
        "deletePersonDto",
        deletePersonDto
      );
      const localVarPath = `/api/v1/person/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePersonDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditPersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerEdit: async (
      person: EditPersonExtendedDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'person' is not null or undefined
      assertParamExists("personControllerEdit", "person", person);
      const localVarPath = `/api/v1/person/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (person !== undefined) {
        localVarFormParams.append("person", JSON.stringify(person));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/person/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PersonApi - functional programming interface
 * @export
 */
export const PersonApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PersonApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerAttachFile(
          code,
          attachmentType,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerAttachFile"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {BlockPersonDto} blockPersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerBlock(
      blockPersonDto: BlockPersonDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerBlock(
          blockPersonDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerBlock"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerCreate(
      person: CreatePersonExtendedDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerCreate(
          person,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePersonDto} deletePersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerDelete(
      deletePersonDto: DeletePersonDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerDelete(
          deletePersonDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditPersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerEdit(
      person: EditPersonExtendedDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerEdit(
          person,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonApi.personControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PersonApi - factory interface
 * @export
 */
export const PersonApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PersonApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .personControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerAttachFile(code, attachmentType, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BlockPersonDto} blockPersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerBlock(
      blockPersonDto: BlockPersonDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerBlock(blockPersonDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerCreate(
      person: CreatePersonExtendedDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerCreate(person, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePersonDto} deletePersonDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerDelete(
      deletePersonDto: DeletePersonDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerDelete(deletePersonDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditPersonExtendedDto} person
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerEdit(
      person: EditPersonExtendedDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personControllerEdit(person, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerGet200Response> {
      return localVarFp
        .personControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PersonApi - object-oriented interface
 * @export
 * @class PersonApi
 * @extends {BaseAPI}
 */
export class PersonApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} code
   * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerAttachFile(
    code: string,
    attachmentType: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerAttachFile(code, attachmentType, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BlockPersonDto} blockPersonDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerBlock(
    blockPersonDto: BlockPersonDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerBlock(blockPersonDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePersonExtendedDto} person
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerCreate(
    person: CreatePersonExtendedDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerCreate(person, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePersonDto} deletePersonDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerDelete(
    deletePersonDto: DeletePersonDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerDelete(deletePersonDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditPersonExtendedDto} person
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerEdit(
    person: EditPersonExtendedDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerEdit(person, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonApi
   */
  public personControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PersonApiFp(this.configuration)
      .personControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PersonAddressApi - axios parameter creator
 * @export
 */
export const PersonAddressApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/person-address/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePersonAddressDto} createPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerCreate: async (
      createPersonAddressDto: CreatePersonAddressDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createPersonAddressDto' is not null or undefined
      assertParamExists(
        "personAddressControllerCreate",
        "createPersonAddressDto",
        createPersonAddressDto
      );
      const localVarPath = `/api/v1/person-address/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPersonAddressDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeletePersonAddressDto} deletePersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerDelete: async (
      deletePersonAddressDto: DeletePersonAddressDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePersonAddressDto' is not null or undefined
      assertParamExists(
        "personAddressControllerDelete",
        "deletePersonAddressDto",
        deletePersonAddressDto
      );
      const localVarPath = `/api/v1/person-address/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePersonAddressDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditPersonAddressDto} editPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerEdit: async (
      editPersonAddressDto: EditPersonAddressDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editPersonAddressDto' is not null or undefined
      assertParamExists(
        "personAddressControllerEdit",
        "editPersonAddressDto",
        editPersonAddressDto
      );
      const localVarPath = `/api/v1/person-address/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editPersonAddressDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/person-address/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PersonAddressApi - functional programming interface
 * @export
 */
export const PersonAddressApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    PersonAddressApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "PersonAddressApi.personAddressControllerActivity"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePersonAddressDto} createPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerCreate(
      createPersonAddressDto: CreatePersonAddressDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerCreate(
          createPersonAddressDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonAddressApi.personAddressControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeletePersonAddressDto} deletePersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerDelete(
      deletePersonAddressDto: DeletePersonAddressDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerDelete(
          deletePersonAddressDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonAddressApi.personAddressControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditPersonAddressDto} editPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerEdit(
      editPersonAddressDto: EditPersonAddressDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerEdit(
          editPersonAddressDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonAddressApi.personAddressControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async personAddressControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonAddressControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.personAddressControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PersonAddressApi.personAddressControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PersonAddressApi - factory interface
 * @export
 */
export const PersonAddressApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PersonAddressApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .personAddressControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePersonAddressDto} createPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerCreate(
      createPersonAddressDto: CreatePersonAddressDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personAddressControllerCreate(createPersonAddressDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeletePersonAddressDto} deletePersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerDelete(
      deletePersonAddressDto: DeletePersonAddressDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personAddressControllerDelete(deletePersonAddressDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditPersonAddressDto} editPersonAddressDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerEdit(
      editPersonAddressDto: EditPersonAddressDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .personAddressControllerEdit(editPersonAddressDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    personAddressControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonAddressControllerGet200Response> {
      return localVarFp
        .personAddressControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PersonAddressApi - object-oriented interface
 * @export
 * @class PersonAddressApi
 * @extends {BaseAPI}
 */
export class PersonAddressApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePersonAddressDto} createPersonAddressDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerCreate(
    createPersonAddressDto: CreatePersonAddressDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerCreate(createPersonAddressDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeletePersonAddressDto} deletePersonAddressDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerDelete(
    deletePersonAddressDto: DeletePersonAddressDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerDelete(deletePersonAddressDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditPersonAddressDto} editPersonAddressDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerEdit(
    editPersonAddressDto: EditPersonAddressDto,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerEdit(editPersonAddressDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PersonAddressApi
   */
  public personAddressControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PersonAddressApiFp(this.configuration)
      .personAddressControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RegistrationApi - axios parameter creator
 * @export
 */
export const RegistrationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/registration/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateRegistrationDto} createRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerCreate: async (
      createRegistrationDto: CreateRegistrationDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createRegistrationDto' is not null or undefined
      assertParamExists(
        "registrationControllerCreate",
        "createRegistrationDto",
        createRegistrationDto
      );
      const localVarPath = `/api/v1/registration/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRegistrationDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteRegistrationDto} deleteRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerDelete: async (
      deleteRegistrationDto: DeleteRegistrationDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteRegistrationDto' is not null or undefined
      assertParamExists(
        "registrationControllerDelete",
        "deleteRegistrationDto",
        deleteRegistrationDto
      );
      const localVarPath = `/api/v1/registration/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRegistrationDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditRegistrationDto} editRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerEdit: async (
      editRegistrationDto: EditRegistrationDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editRegistrationDto' is not null or undefined
      assertParamExists(
        "registrationControllerEdit",
        "editRegistrationDto",
        editRegistrationDto
      );
      const localVarPath = `/api/v1/registration/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editRegistrationDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ApproveDto} approveDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerEnd: async (
      approveDto: ApproveDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'approveDto' is not null or undefined
      assertParamExists("registrationControllerEnd", "approveDto", approveDto);
      const localVarPath = `/api/v1/registration/approve`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        approveDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/registration/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RegistrationApi - functional programming interface
 * @export
 */
export const RegistrationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RegistrationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registrationControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registrationControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RegistrationApi.registrationControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateRegistrationDto} createRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registrationControllerCreate(
      createRegistrationDto: CreateRegistrationDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registrationControllerCreate(
          createRegistrationDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RegistrationApi.registrationControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteRegistrationDto} deleteRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registrationControllerDelete(
      deleteRegistrationDto: DeleteRegistrationDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registrationControllerDelete(
          deleteRegistrationDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RegistrationApi.registrationControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditRegistrationDto} editRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registrationControllerEdit(
      editRegistrationDto: EditRegistrationDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registrationControllerEdit(
          editRegistrationDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RegistrationApi.registrationControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {ApproveDto} approveDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registrationControllerEnd(
      approveDto: ApproveDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registrationControllerEnd(
          approveDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RegistrationApi.registrationControllerEnd"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async registrationControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<RegistrationControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.registrationControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RegistrationApi.registrationControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RegistrationApi - factory interface
 * @export
 */
export const RegistrationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RegistrationApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .registrationControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateRegistrationDto} createRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerCreate(
      createRegistrationDto: CreateRegistrationDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .registrationControllerCreate(createRegistrationDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteRegistrationDto} deleteRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerDelete(
      deleteRegistrationDto: DeleteRegistrationDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .registrationControllerDelete(deleteRegistrationDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditRegistrationDto} editRegistrationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerEdit(
      editRegistrationDto: EditRegistrationDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .registrationControllerEdit(editRegistrationDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ApproveDto} approveDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerEnd(
      approveDto: ApproveDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .registrationControllerEnd(approveDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registrationControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RegistrationControllerGet200Response> {
      return localVarFp
        .registrationControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RegistrationApi - object-oriented interface
 * @export
 * @class RegistrationApi
 * @extends {BaseAPI}
 */
export class RegistrationApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrationApi
   */
  public registrationControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return RegistrationApiFp(this.configuration)
      .registrationControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateRegistrationDto} createRegistrationDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrationApi
   */
  public registrationControllerCreate(
    createRegistrationDto: CreateRegistrationDto,
    options?: RawAxiosRequestConfig
  ) {
    return RegistrationApiFp(this.configuration)
      .registrationControllerCreate(createRegistrationDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteRegistrationDto} deleteRegistrationDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrationApi
   */
  public registrationControllerDelete(
    deleteRegistrationDto: DeleteRegistrationDto,
    options?: RawAxiosRequestConfig
  ) {
    return RegistrationApiFp(this.configuration)
      .registrationControllerDelete(deleteRegistrationDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditRegistrationDto} editRegistrationDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrationApi
   */
  public registrationControllerEdit(
    editRegistrationDto: EditRegistrationDto,
    options?: RawAxiosRequestConfig
  ) {
    return RegistrationApiFp(this.configuration)
      .registrationControllerEdit(editRegistrationDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ApproveDto} approveDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrationApi
   */
  public registrationControllerEnd(
    approveDto: ApproveDto,
    options?: RawAxiosRequestConfig
  ) {
    return RegistrationApiFp(this.configuration)
      .registrationControllerEnd(approveDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrationApi
   */
  public registrationControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return RegistrationApiFp(this.configuration)
      .registrationControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SchedulerApi - axios parameter creator
 * @export
 */
export const SchedulerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    schedulerControllerNoClockout: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/scheduler/default`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SchedulerApi - functional programming interface
 * @export
 */
export const SchedulerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    SchedulerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async schedulerControllerNoClockout(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.schedulerControllerNoClockout(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["SchedulerApi.schedulerControllerNoClockout"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SchedulerApi - factory interface
 * @export
 */
export const SchedulerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SchedulerApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    schedulerControllerNoClockout(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .schedulerControllerNoClockout(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SchedulerApi - object-oriented interface
 * @export
 * @class SchedulerApi
 * @extends {BaseAPI}
 */
export class SchedulerApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SchedulerApi
   */
  public schedulerControllerNoClockout(options?: RawAxiosRequestConfig) {
    return SchedulerApiFp(this.configuration)
      .schedulerControllerNoClockout(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TenantApi - axios parameter creator
 * @export
 */
export const TenantApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tenant/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerAttachFile: async (
      code: string,
      attachmentType: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists("tenantControllerAttachFile", "code", code);
      // verify required parameter 'attachmentType' is not null or undefined
      assertParamExists(
        "tenantControllerAttachFile",
        "attachmentType",
        attachmentType
      );
      const localVarPath = `/api/v1/tenant/attach-file`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (code !== undefined) {
        localVarFormParams.append("code", code as any);
      }

      if (attachmentType !== undefined) {
        localVarFormParams.append("attachment_type", attachmentType as any);
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateTenantDto} createTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerCreate: async (
      createTenantDto: CreateTenantDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createTenantDto' is not null or undefined
      assertParamExists(
        "tenantControllerCreate",
        "createTenantDto",
        createTenantDto
      );
      const localVarPath = `/api/v1/tenant/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createTenantDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteTenantDto} deleteTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerDelete: async (
      deleteTenantDto: DeleteTenantDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteTenantDto' is not null or undefined
      assertParamExists(
        "tenantControllerDelete",
        "deleteTenantDto",
        deleteTenantDto
      );
      const localVarPath = `/api/v1/tenant/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteTenantDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditTenantDto} editTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerEdit: async (
      editTenantDto: EditTenantDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editTenantDto' is not null or undefined
      assertParamExists("tenantControllerEdit", "editTenantDto", editTenantDto);
      const localVarPath = `/api/v1/tenant/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editTenantDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tenant/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerAttachFile(
          code,
          attachmentType,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerAttachFile"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateTenantDto} createTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerCreate(
      createTenantDto: CreateTenantDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerCreate(
          createTenantDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteTenantDto} deleteTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerDelete(
      deleteTenantDto: DeleteTenantDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerDelete(
          deleteTenantDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditTenantDto} editTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerEdit(
      editTenantDto: EditTenantDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerEdit(
          editTenantDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TenantControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TenantApi.tenantControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TenantApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .tenantControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} code
     * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerAttachFile(
      code: string,
      attachmentType: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .tenantControllerAttachFile(code, attachmentType, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateTenantDto} createTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerCreate(
      createTenantDto: CreateTenantDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .tenantControllerCreate(createTenantDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteTenantDto} deleteTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerDelete(
      deleteTenantDto: DeleteTenantDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .tenantControllerDelete(deleteTenantDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditTenantDto} editTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerEdit(
      editTenantDto: EditTenantDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .tenantControllerEdit(editTenantDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TenantControllerGet200Response> {
      return localVarFp
        .tenantControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} code
   * @param {string} attachmentType curriculum_vitae, supporting_doc, intent_letter, application_letter, avatar
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerAttachFile(
    code: string,
    attachmentType: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerAttachFile(code, attachmentType, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateTenantDto} createTenantDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerCreate(
    createTenantDto: CreateTenantDto,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerCreate(createTenantDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteTenantDto} deleteTenantDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerDelete(
    deleteTenantDto: DeleteTenantDto,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerDelete(deleteTenantDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditTenantDto} editTenantDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerEdit(
    editTenantDto: EditTenantDto,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerEdit(editTenantDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantApi
   */
  public tenantControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TenantApiFp(this.configuration)
      .tenantControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityAttachmentTypeApi - axios parameter creator
 * @export
 */
export const UtilityAttachmentTypeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-attachment-type/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateAttachmentTypeDto} createAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerCreate: async (
      createAttachmentTypeDto: CreateAttachmentTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createAttachmentTypeDto' is not null or undefined
      assertParamExists(
        "utilAttachmentTypeControllerCreate",
        "createAttachmentTypeDto",
        createAttachmentTypeDto
      );
      const localVarPath = `/api/v1/util-attachment-type/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAttachmentTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerDelete: async (
      deleteAttachmentTypeDto: DeleteAttachmentTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteAttachmentTypeDto' is not null or undefined
      assertParamExists(
        "utilAttachmentTypeControllerDelete",
        "deleteAttachmentTypeDto",
        deleteAttachmentTypeDto
      );
      const localVarPath = `/api/v1/util-attachment-type/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteAttachmentTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditAttachmentTypeDto} editAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerEdit: async (
      editAttachmentTypeDto: EditAttachmentTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editAttachmentTypeDto' is not null or undefined
      assertParamExists(
        "utilAttachmentTypeControllerEdit",
        "editAttachmentTypeDto",
        editAttachmentTypeDto
      );
      const localVarPath = `/api/v1/util-attachment-type/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editAttachmentTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-attachment-type/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityAttachmentTypeApi - functional programming interface
 * @export
 */
export const UtilityAttachmentTypeApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    UtilityAttachmentTypeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerActivity"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateAttachmentTypeDto} createAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerCreate(
      createAttachmentTypeDto: CreateAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerCreate(
          createAttachmentTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerDelete(
      deleteAttachmentTypeDto: DeleteAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerDelete(
          deleteAttachmentTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditAttachmentTypeDto} editAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerEdit(
      editAttachmentTypeDto: EditAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerEdit(
          editAttachmentTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerEdit"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilAttachmentTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilAttachmentTypeControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilAttachmentTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityAttachmentTypeApi.utilAttachmentTypeControllerGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityAttachmentTypeApi - factory interface
 * @export
 */
export const UtilityAttachmentTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityAttachmentTypeApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilAttachmentTypeControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateAttachmentTypeDto} createAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerCreate(
      createAttachmentTypeDto: CreateAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilAttachmentTypeControllerCreate(createAttachmentTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerDelete(
      deleteAttachmentTypeDto: DeleteAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditAttachmentTypeDto} editAttachmentTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerEdit(
      editAttachmentTypeDto: EditAttachmentTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilAttachmentTypeControllerEdit(editAttachmentTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilAttachmentTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilAttachmentTypeControllerGet200Response> {
      return localVarFp
        .utilAttachmentTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityAttachmentTypeApi - object-oriented interface
 * @export
 * @class UtilityAttachmentTypeApi
 * @extends {BaseAPI}
 */
export class UtilityAttachmentTypeApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateAttachmentTypeDto} createAttachmentTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerCreate(
    createAttachmentTypeDto: CreateAttachmentTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerCreate(createAttachmentTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteAttachmentTypeDto} deleteAttachmentTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerDelete(
    deleteAttachmentTypeDto: DeleteAttachmentTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerDelete(deleteAttachmentTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditAttachmentTypeDto} editAttachmentTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerEdit(
    editAttachmentTypeDto: EditAttachmentTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerEdit(editAttachmentTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityAttachmentTypeApi
   */
  public utilAttachmentTypeControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityAttachmentTypeApiFp(this.configuration)
      .utilAttachmentTypeControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityConfigApi - axios parameter creator
 * @export
 */
export const UtilityConfigApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-config/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateConfigDto} createConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerCreate: async (
      createConfigDto: CreateConfigDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createConfigDto' is not null or undefined
      assertParamExists(
        "utilConfigControllerCreate",
        "createConfigDto",
        createConfigDto
      );
      const localVarPath = `/api/v1/util-config/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createConfigDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteConfigDto} deleteConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerDelete: async (
      deleteConfigDto: DeleteConfigDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteConfigDto' is not null or undefined
      assertParamExists(
        "utilConfigControllerDelete",
        "deleteConfigDto",
        deleteConfigDto
      );
      const localVarPath = `/api/v1/util-config/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteConfigDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditConfigDto} editConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerEdit: async (
      editConfigDto: EditConfigDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editConfigDto' is not null or undefined
      assertParamExists(
        "utilConfigControllerEdit",
        "editConfigDto",
        editConfigDto
      );
      const localVarPath = `/api/v1/util-config/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editConfigDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-config/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityConfigApi - functional programming interface
 * @export
 */
export const UtilityConfigApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityConfigApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateConfigDto} createConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerCreate(
      createConfigDto: CreateConfigDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerCreate(
          createConfigDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteConfigDto} deleteConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerDelete(
      deleteConfigDto: DeleteConfigDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerDelete(
          deleteConfigDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditConfigDto} editConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerEdit(
      editConfigDto: EditConfigDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerEdit(
          editConfigDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilConfigControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilConfigControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilConfigControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityConfigApi.utilConfigControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityConfigApi - factory interface
 * @export
 */
export const UtilityConfigApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityConfigApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilConfigControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateConfigDto} createConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerCreate(
      createConfigDto: CreateConfigDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilConfigControllerCreate(createConfigDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteConfigDto} deleteConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerDelete(
      deleteConfigDto: DeleteConfigDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilConfigControllerDelete(deleteConfigDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditConfigDto} editConfigDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerEdit(
      editConfigDto: EditConfigDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilConfigControllerEdit(editConfigDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilConfigControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilConfigControllerGet200Response> {
      return localVarFp
        .utilConfigControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityConfigApi - object-oriented interface
 * @export
 * @class UtilityConfigApi
 * @extends {BaseAPI}
 */
export class UtilityConfigApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateConfigDto} createConfigDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerCreate(
    createConfigDto: CreateConfigDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerCreate(createConfigDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteConfigDto} deleteConfigDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerDelete(
    deleteConfigDto: DeleteConfigDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerDelete(deleteConfigDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditConfigDto} editConfigDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerEdit(
    editConfigDto: EditConfigDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerEdit(editConfigDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityConfigApi
   */
  public utilConfigControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityConfigApiFp(this.configuration)
      .utilConfigControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityCreditTypeApi - axios parameter creator
 * @export
 */
export const UtilityCreditTypeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-credit-type/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateCreditTypeDto} createCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerCreate: async (
      createCreditTypeDto: CreateCreditTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createCreditTypeDto' is not null or undefined
      assertParamExists(
        "utilCreditTypeControllerCreate",
        "createCreditTypeDto",
        createCreditTypeDto
      );
      const localVarPath = `/api/v1/util-credit-type/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCreditTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteCreditTypeDto} deleteCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerDelete: async (
      deleteCreditTypeDto: DeleteCreditTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteCreditTypeDto' is not null or undefined
      assertParamExists(
        "utilCreditTypeControllerDelete",
        "deleteCreditTypeDto",
        deleteCreditTypeDto
      );
      const localVarPath = `/api/v1/util-credit-type/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteCreditTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditCreditTypeDto} editCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerEdit: async (
      editCreditTypeDto: EditCreditTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editCreditTypeDto' is not null or undefined
      assertParamExists(
        "utilCreditTypeControllerEdit",
        "editCreditTypeDto",
        editCreditTypeDto
      );
      const localVarPath = `/api/v1/util-credit-type/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editCreditTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-credit-type/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityCreditTypeApi - functional programming interface
 * @export
 */
export const UtilityCreditTypeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityCreditTypeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilCreditTypeControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilCreditTypeControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityCreditTypeApi.utilCreditTypeControllerActivity"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateCreditTypeDto} createCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilCreditTypeControllerCreate(
      createCreditTypeDto: CreateCreditTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilCreditTypeControllerCreate(
          createCreditTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityCreditTypeApi.utilCreditTypeControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteCreditTypeDto} deleteCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilCreditTypeControllerDelete(
      deleteCreditTypeDto: DeleteCreditTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilCreditTypeControllerDelete(
          deleteCreditTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityCreditTypeApi.utilCreditTypeControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditCreditTypeDto} editCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilCreditTypeControllerEdit(
      editCreditTypeDto: EditCreditTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilCreditTypeControllerEdit(
          editCreditTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityCreditTypeApi.utilCreditTypeControllerEdit"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilCreditTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilCreditTypeControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilCreditTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityCreditTypeApi.utilCreditTypeControllerGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityCreditTypeApi - factory interface
 * @export
 */
export const UtilityCreditTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityCreditTypeApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilCreditTypeControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateCreditTypeDto} createCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerCreate(
      createCreditTypeDto: CreateCreditTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilCreditTypeControllerCreate(createCreditTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteCreditTypeDto} deleteCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerDelete(
      deleteCreditTypeDto: DeleteCreditTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilCreditTypeControllerDelete(deleteCreditTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditCreditTypeDto} editCreditTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerEdit(
      editCreditTypeDto: EditCreditTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilCreditTypeControllerEdit(editCreditTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilCreditTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilCreditTypeControllerGet200Response> {
      return localVarFp
        .utilCreditTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityCreditTypeApi - object-oriented interface
 * @export
 * @class UtilityCreditTypeApi
 * @extends {BaseAPI}
 */
export class UtilityCreditTypeApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityCreditTypeApi
   */
  public utilCreditTypeControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityCreditTypeApiFp(this.configuration)
      .utilCreditTypeControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateCreditTypeDto} createCreditTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityCreditTypeApi
   */
  public utilCreditTypeControllerCreate(
    createCreditTypeDto: CreateCreditTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityCreditTypeApiFp(this.configuration)
      .utilCreditTypeControllerCreate(createCreditTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteCreditTypeDto} deleteCreditTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityCreditTypeApi
   */
  public utilCreditTypeControllerDelete(
    deleteCreditTypeDto: DeleteCreditTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityCreditTypeApiFp(this.configuration)
      .utilCreditTypeControllerDelete(deleteCreditTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditCreditTypeDto} editCreditTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityCreditTypeApi
   */
  public utilCreditTypeControllerEdit(
    editCreditTypeDto: EditCreditTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityCreditTypeApiFp(this.configuration)
      .utilCreditTypeControllerEdit(editCreditTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityCreditTypeApi
   */
  public utilCreditTypeControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityCreditTypeApiFp(this.configuration)
      .utilCreditTypeControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityDebitTypeApi - axios parameter creator
 * @export
 */
export const UtilityDebitTypeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-debit-type/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateDebitTypeDto} createDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerCreate: async (
      createDebitTypeDto: CreateDebitTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createDebitTypeDto' is not null or undefined
      assertParamExists(
        "utilDebitTypeControllerCreate",
        "createDebitTypeDto",
        createDebitTypeDto
      );
      const localVarPath = `/api/v1/util-debit-type/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createDebitTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteDebitTypeDto} deleteDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerDelete: async (
      deleteDebitTypeDto: DeleteDebitTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteDebitTypeDto' is not null or undefined
      assertParamExists(
        "utilDebitTypeControllerDelete",
        "deleteDebitTypeDto",
        deleteDebitTypeDto
      );
      const localVarPath = `/api/v1/util-debit-type/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteDebitTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditDebitTypeDto} editDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerEdit: async (
      editDebitTypeDto: EditDebitTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editDebitTypeDto' is not null or undefined
      assertParamExists(
        "utilDebitTypeControllerEdit",
        "editDebitTypeDto",
        editDebitTypeDto
      );
      const localVarPath = `/api/v1/util-debit-type/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editDebitTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-debit-type/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityDebitTypeApi - functional programming interface
 * @export
 */
export const UtilityDebitTypeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityDebitTypeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilDebitTypeControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilDebitTypeControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityDebitTypeApi.utilDebitTypeControllerActivity"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateDebitTypeDto} createDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilDebitTypeControllerCreate(
      createDebitTypeDto: CreateDebitTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilDebitTypeControllerCreate(
          createDebitTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityDebitTypeApi.utilDebitTypeControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteDebitTypeDto} deleteDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilDebitTypeControllerDelete(
      deleteDebitTypeDto: DeleteDebitTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilDebitTypeControllerDelete(
          deleteDebitTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityDebitTypeApi.utilDebitTypeControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditDebitTypeDto} editDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilDebitTypeControllerEdit(
      editDebitTypeDto: EditDebitTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilDebitTypeControllerEdit(
          editDebitTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityDebitTypeApi.utilDebitTypeControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilDebitTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilDebitTypeControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilDebitTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityDebitTypeApi.utilDebitTypeControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityDebitTypeApi - factory interface
 * @export
 */
export const UtilityDebitTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityDebitTypeApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilDebitTypeControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateDebitTypeDto} createDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerCreate(
      createDebitTypeDto: CreateDebitTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilDebitTypeControllerCreate(createDebitTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteDebitTypeDto} deleteDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerDelete(
      deleteDebitTypeDto: DeleteDebitTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilDebitTypeControllerDelete(deleteDebitTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditDebitTypeDto} editDebitTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerEdit(
      editDebitTypeDto: EditDebitTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilDebitTypeControllerEdit(editDebitTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilDebitTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilDebitTypeControllerGet200Response> {
      return localVarFp
        .utilDebitTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityDebitTypeApi - object-oriented interface
 * @export
 * @class UtilityDebitTypeApi
 * @extends {BaseAPI}
 */
export class UtilityDebitTypeApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityDebitTypeApi
   */
  public utilDebitTypeControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityDebitTypeApiFp(this.configuration)
      .utilDebitTypeControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateDebitTypeDto} createDebitTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityDebitTypeApi
   */
  public utilDebitTypeControllerCreate(
    createDebitTypeDto: CreateDebitTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityDebitTypeApiFp(this.configuration)
      .utilDebitTypeControllerCreate(createDebitTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteDebitTypeDto} deleteDebitTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityDebitTypeApi
   */
  public utilDebitTypeControllerDelete(
    deleteDebitTypeDto: DeleteDebitTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityDebitTypeApiFp(this.configuration)
      .utilDebitTypeControllerDelete(deleteDebitTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditDebitTypeDto} editDebitTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityDebitTypeApi
   */
  public utilDebitTypeControllerEdit(
    editDebitTypeDto: EditDebitTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityDebitTypeApiFp(this.configuration)
      .utilDebitTypeControllerEdit(editDebitTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityDebitTypeApi
   */
  public utilDebitTypeControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityDebitTypeApiFp(this.configuration)
      .utilDebitTypeControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityItemApi - axios parameter creator
 * @export
 */
export const UtilityItemApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-item/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateItemDto} createItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerCreate: async (
      createItemDto: CreateItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createItemDto' is not null or undefined
      assertParamExists(
        "utilItemControllerCreate",
        "createItemDto",
        createItemDto
      );
      const localVarPath = `/api/v1/util-item/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteItemDto} deleteItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerDelete: async (
      deleteItemDto: DeleteItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteItemDto' is not null or undefined
      assertParamExists(
        "utilItemControllerDelete",
        "deleteItemDto",
        deleteItemDto
      );
      const localVarPath = `/api/v1/util-item/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditItemDto} editItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerEdit: async (
      editItemDto: EditItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editItemDto' is not null or undefined
      assertParamExists("utilItemControllerEdit", "editItemDto", editItemDto);
      const localVarPath = `/api/v1/util-item/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-item/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityItemApi - functional programming interface
 * @export
 */
export const UtilityItemApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityItemApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateItemDto} createItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerCreate(
      createItemDto: CreateItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerCreate(
          createItemDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteItemDto} deleteItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerDelete(
      deleteItemDto: DeleteItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerDelete(
          deleteItemDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditItemDto} editItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerEdit(
      editItemDto: EditItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerEdit(
          editItemDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilItemControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilItemControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilItemControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityItemApi.utilItemControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityItemApi - factory interface
 * @export
 */
export const UtilityItemApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityItemApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilItemControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateItemDto} createItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerCreate(
      createItemDto: CreateItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilItemControllerCreate(createItemDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteItemDto} deleteItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerDelete(
      deleteItemDto: DeleteItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilItemControllerDelete(deleteItemDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditItemDto} editItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerEdit(
      editItemDto: EditItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilItemControllerEdit(editItemDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilItemControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilItemControllerGet200Response> {
      return localVarFp
        .utilItemControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityItemApi - object-oriented interface
 * @export
 * @class UtilityItemApi
 * @extends {BaseAPI}
 */
export class UtilityItemApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateItemDto} createItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerCreate(
    createItemDto: CreateItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerCreate(createItemDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteItemDto} deleteItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerDelete(
    deleteItemDto: DeleteItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerDelete(deleteItemDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditItemDto} editItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerEdit(
    editItemDto: EditItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerEdit(editItemDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityItemApi
   */
  public utilItemControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityItemApiFp(this.configuration)
      .utilItemControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityProviderTypeApi - axios parameter creator
 * @export
 */
export const UtilityProviderTypeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-provider-type/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateProviderTypeDto} createProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerCreate: async (
      createProviderTypeDto: CreateProviderTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createProviderTypeDto' is not null or undefined
      assertParamExists(
        "utilProviderTypeControllerCreate",
        "createProviderTypeDto",
        createProviderTypeDto
      );
      const localVarPath = `/api/v1/util-provider-type/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createProviderTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteProviderTypeDto} deleteProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerDelete: async (
      deleteProviderTypeDto: DeleteProviderTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteProviderTypeDto' is not null or undefined
      assertParamExists(
        "utilProviderTypeControllerDelete",
        "deleteProviderTypeDto",
        deleteProviderTypeDto
      );
      const localVarPath = `/api/v1/util-provider-type/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteProviderTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditProviderTypeDto} editProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerEdit: async (
      editProviderTypeDto: EditProviderTypeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editProviderTypeDto' is not null or undefined
      assertParamExists(
        "utilProviderTypeControllerEdit",
        "editProviderTypeDto",
        editProviderTypeDto
      );
      const localVarPath = `/api/v1/util-provider-type/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editProviderTypeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-provider-type/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityProviderTypeApi - functional programming interface
 * @export
 */
export const UtilityProviderTypeApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    UtilityProviderTypeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilProviderTypeControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilProviderTypeControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityProviderTypeApi.utilProviderTypeControllerActivity"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateProviderTypeDto} createProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilProviderTypeControllerCreate(
      createProviderTypeDto: CreateProviderTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilProviderTypeControllerCreate(
          createProviderTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityProviderTypeApi.utilProviderTypeControllerCreate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteProviderTypeDto} deleteProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilProviderTypeControllerDelete(
      deleteProviderTypeDto: DeleteProviderTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilProviderTypeControllerDelete(
          deleteProviderTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityProviderTypeApi.utilProviderTypeControllerDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditProviderTypeDto} editProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilProviderTypeControllerEdit(
      editProviderTypeDto: EditProviderTypeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilProviderTypeControllerEdit(
          editProviderTypeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityProviderTypeApi.utilProviderTypeControllerEdit"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilProviderTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilProviderTypeControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilProviderTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityProviderTypeApi.utilProviderTypeControllerGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityProviderTypeApi - factory interface
 * @export
 */
export const UtilityProviderTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityProviderTypeApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilProviderTypeControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateProviderTypeDto} createProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerCreate(
      createProviderTypeDto: CreateProviderTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilProviderTypeControllerCreate(createProviderTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteProviderTypeDto} deleteProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerDelete(
      deleteProviderTypeDto: DeleteProviderTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilProviderTypeControllerDelete(deleteProviderTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditProviderTypeDto} editProviderTypeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerEdit(
      editProviderTypeDto: EditProviderTypeDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilProviderTypeControllerEdit(editProviderTypeDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilProviderTypeControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilProviderTypeControllerGet200Response> {
      return localVarFp
        .utilProviderTypeControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityProviderTypeApi - object-oriented interface
 * @export
 * @class UtilityProviderTypeApi
 * @extends {BaseAPI}
 */
export class UtilityProviderTypeApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityProviderTypeApi
   */
  public utilProviderTypeControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityProviderTypeApiFp(this.configuration)
      .utilProviderTypeControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateProviderTypeDto} createProviderTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityProviderTypeApi
   */
  public utilProviderTypeControllerCreate(
    createProviderTypeDto: CreateProviderTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityProviderTypeApiFp(this.configuration)
      .utilProviderTypeControllerCreate(createProviderTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteProviderTypeDto} deleteProviderTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityProviderTypeApi
   */
  public utilProviderTypeControllerDelete(
    deleteProviderTypeDto: DeleteProviderTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityProviderTypeApiFp(this.configuration)
      .utilProviderTypeControllerDelete(deleteProviderTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditProviderTypeDto} editProviderTypeDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityProviderTypeApi
   */
  public utilProviderTypeControllerEdit(
    editProviderTypeDto: EditProviderTypeDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityProviderTypeApiFp(this.configuration)
      .utilProviderTypeControllerEdit(editProviderTypeDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityProviderTypeApi
   */
  public utilProviderTypeControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityProviderTypeApiFp(this.configuration)
      .utilProviderTypeControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityRoleApi - axios parameter creator
 * @export
 */
export const UtilityRoleApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-role/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerCreate: async (
      createRoleDto: CreateRoleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createRoleDto' is not null or undefined
      assertParamExists(
        "utilRoleControllerCreate",
        "createRoleDto",
        createRoleDto
      );
      const localVarPath = `/api/v1/util-role/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRoleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteRoleDto} deleteRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerDelete: async (
      deleteRoleDto: DeleteRoleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteRoleDto' is not null or undefined
      assertParamExists(
        "utilRoleControllerDelete",
        "deleteRoleDto",
        deleteRoleDto
      );
      const localVarPath = `/api/v1/util-role/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRoleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditRoleDto} editRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerEdit: async (
      editRoleDto: EditRoleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editRoleDto' is not null or undefined
      assertParamExists("utilRoleControllerEdit", "editRoleDto", editRoleDto);
      const localVarPath = `/api/v1/util-role/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editRoleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-role/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityRoleApi - functional programming interface
 * @export
 */
export const UtilityRoleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityRoleApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerCreate(
      createRoleDto: CreateRoleDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerCreate(
          createRoleDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteRoleDto} deleteRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerDelete(
      deleteRoleDto: DeleteRoleDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerDelete(
          deleteRoleDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditRoleDto} editRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerEdit(
      editRoleDto: EditRoleDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerEdit(
          editRoleDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilRoleControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilRoleControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilRoleControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityRoleApi.utilRoleControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityRoleApi - factory interface
 * @export
 */
export const UtilityRoleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityRoleApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilRoleControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerCreate(
      createRoleDto: CreateRoleDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRoleControllerCreate(createRoleDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteRoleDto} deleteRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerDelete(
      deleteRoleDto: DeleteRoleDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRoleControllerDelete(deleteRoleDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditRoleDto} editRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerEdit(
      editRoleDto: EditRoleDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilRoleControllerEdit(editRoleDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilRoleControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilRoleControllerGet200Response> {
      return localVarFp
        .utilRoleControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityRoleApi - object-oriented interface
 * @export
 * @class UtilityRoleApi
 * @extends {BaseAPI}
 */
export class UtilityRoleApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateRoleDto} createRoleDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerCreate(
    createRoleDto: CreateRoleDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerCreate(createRoleDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteRoleDto} deleteRoleDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerDelete(
    deleteRoleDto: DeleteRoleDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerDelete(deleteRoleDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditRoleDto} editRoleDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerEdit(
    editRoleDto: EditRoleDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerEdit(editRoleDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityRoleApi
   */
  public utilRoleControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityRoleApiFp(this.configuration)
      .utilRoleControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityServiceApi - axios parameter creator
 * @export
 */
export const UtilityServiceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-service/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateUtilServiceDto} createUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerCreate: async (
      createUtilServiceDto: CreateUtilServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createUtilServiceDto' is not null or undefined
      assertParamExists(
        "utilServiceControllerCreate",
        "createUtilServiceDto",
        createUtilServiceDto
      );
      const localVarPath = `/api/v1/util-service/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createUtilServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteUtilServiceDto} deleteUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerDelete: async (
      deleteUtilServiceDto: DeleteUtilServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteUtilServiceDto' is not null or undefined
      assertParamExists(
        "utilServiceControllerDelete",
        "deleteUtilServiceDto",
        deleteUtilServiceDto
      );
      const localVarPath = `/api/v1/util-service/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteUtilServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditUtilServiceDto} editUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerEdit: async (
      editUtilServiceDto: EditUtilServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editUtilServiceDto' is not null or undefined
      assertParamExists(
        "utilServiceControllerEdit",
        "editUtilServiceDto",
        editUtilServiceDto
      );
      const localVarPath = `/api/v1/util-service/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editUtilServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-service/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetTenantServiceDto} getTenantServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerGetPublic: async (
      getTenantServiceDto: GetTenantServiceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'getTenantServiceDto' is not null or undefined
      assertParamExists(
        "utilServiceControllerGetPublic",
        "getTenantServiceDto",
        getTenantServiceDto
      );
      const localVarPath = `/api/v1/util-service/public`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getTenantServiceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityServiceApi - functional programming interface
 * @export
 */
export const UtilityServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityServiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateUtilServiceDto} createUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerCreate(
      createUtilServiceDto: CreateUtilServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerCreate(
          createUtilServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteUtilServiceDto} deleteUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerDelete(
      deleteUtilServiceDto: DeleteUtilServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerDelete(
          deleteUtilServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditUtilServiceDto} editUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerEdit(
      editUtilServiceDto: EditUtilServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerEdit(
          editUtilServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilServiceControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityServiceApi.utilServiceControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {GetTenantServiceDto} getTenantServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilServiceControllerGetPublic(
      getTenantServiceDto: GetTenantServiceDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilServiceControllerGetPublic(
          getTenantServiceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "UtilityServiceApi.utilServiceControllerGetPublic"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityServiceApi - factory interface
 * @export
 */
export const UtilityServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityServiceApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilServiceControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateUtilServiceDto} createUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerCreate(
      createUtilServiceDto: CreateUtilServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilServiceControllerCreate(createUtilServiceDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteUtilServiceDto} deleteUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerDelete(
      deleteUtilServiceDto: DeleteUtilServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilServiceControllerDelete(deleteUtilServiceDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditUtilServiceDto} editUtilServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerEdit(
      editUtilServiceDto: EditUtilServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilServiceControllerEdit(editUtilServiceDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilServiceControllerGet200Response> {
      return localVarFp
        .utilServiceControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetTenantServiceDto} getTenantServiceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilServiceControllerGetPublic(
      getTenantServiceDto: GetTenantServiceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<object> {
      return localVarFp
        .utilServiceControllerGetPublic(getTenantServiceDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityServiceApi - object-oriented interface
 * @export
 * @class UtilityServiceApi
 * @extends {BaseAPI}
 */
export class UtilityServiceApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateUtilServiceDto} createUtilServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerCreate(
    createUtilServiceDto: CreateUtilServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerCreate(createUtilServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteUtilServiceDto} deleteUtilServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerDelete(
    deleteUtilServiceDto: DeleteUtilServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerDelete(deleteUtilServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditUtilServiceDto} editUtilServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerEdit(
    editUtilServiceDto: EditUtilServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerEdit(editUtilServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetTenantServiceDto} getTenantServiceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityServiceApi
   */
  public utilServiceControllerGetPublic(
    getTenantServiceDto: GetTenantServiceDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityServiceApiFp(this.configuration)
      .utilServiceControllerGetPublic(getTenantServiceDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UtilityStatusApi - axios parameter creator
 * @export
 */
export const UtilityStatusApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-status/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateUtilStatusDto} createUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerCreate: async (
      createUtilStatusDto: CreateUtilStatusDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createUtilStatusDto' is not null or undefined
      assertParamExists(
        "utilStatusControllerCreate",
        "createUtilStatusDto",
        createUtilStatusDto
      );
      const localVarPath = `/api/v1/util-status/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createUtilStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteUtilStatusDto} deleteUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerDelete: async (
      deleteUtilStatusDto: DeleteUtilStatusDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteUtilStatusDto' is not null or undefined
      assertParamExists(
        "utilStatusControllerDelete",
        "deleteUtilStatusDto",
        deleteUtilStatusDto
      );
      const localVarPath = `/api/v1/util-status/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteUtilStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditUtilStatusDto} editUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerEdit: async (
      editUtilStatusDto: EditUtilStatusDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editUtilStatusDto' is not null or undefined
      assertParamExists(
        "utilStatusControllerEdit",
        "editUtilStatusDto",
        editUtilStatusDto
      );
      const localVarPath = `/api/v1/util-status/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editUtilStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/util-status/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UtilityStatusApi - functional programming interface
 * @export
 */
export const UtilityStatusApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UtilityStatusApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateUtilStatusDto} createUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerCreate(
      createUtilStatusDto: CreateUtilStatusDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerCreate(
          createUtilStatusDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteUtilStatusDto} deleteUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerDelete(
      deleteUtilStatusDto: DeleteUtilStatusDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerDelete(
          deleteUtilStatusDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditUtilStatusDto} editUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerEdit(
      editUtilStatusDto: EditUtilStatusDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerEdit(
          editUtilStatusDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async utilStatusControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UtilStatusControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.utilStatusControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UtilityStatusApi.utilStatusControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UtilityStatusApi - factory interface
 * @export
 */
export const UtilityStatusApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UtilityStatusApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .utilStatusControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateUtilStatusDto} createUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerCreate(
      createUtilStatusDto: CreateUtilStatusDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilStatusControllerCreate(createUtilStatusDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteUtilStatusDto} deleteUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerDelete(
      deleteUtilStatusDto: DeleteUtilStatusDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilStatusControllerDelete(deleteUtilStatusDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditUtilStatusDto} editUtilStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerEdit(
      editUtilStatusDto: EditUtilStatusDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .utilStatusControllerEdit(editUtilStatusDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    utilStatusControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UtilStatusControllerGet200Response> {
      return localVarFp
        .utilStatusControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UtilityStatusApi - object-oriented interface
 * @export
 * @class UtilityStatusApi
 * @extends {BaseAPI}
 */
export class UtilityStatusApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateUtilStatusDto} createUtilStatusDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerCreate(
    createUtilStatusDto: CreateUtilStatusDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerCreate(createUtilStatusDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteUtilStatusDto} deleteUtilStatusDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerDelete(
    deleteUtilStatusDto: DeleteUtilStatusDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerDelete(deleteUtilStatusDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditUtilStatusDto} editUtilStatusDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerEdit(
    editUtilStatusDto: EditUtilStatusDto,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerEdit(editUtilStatusDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UtilityStatusApi
   */
  public utilStatusControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return UtilityStatusApiFp(this.configuration)
      .utilStatusControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * VisitApi - axios parameter creator
 * @export
 */
export const VisitApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/visit/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateAttachmentVisitBaseDto} attachment
     * @param {Array<File>} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerAttachFile: async (
      attachment: CreateAttachmentVisitBaseDto,
      file?: Array<File>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'attachment' is not null or undefined
      assertParamExists("visitControllerAttachFile", "attachment", attachment);
      const localVarPath = `/api/v1/visit/attach-file`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (attachment !== undefined) {
        localVarFormParams.append("attachment", JSON.stringify(attachment));
      }
      if (file) {
        file.forEach((element) => {
          localVarFormParams.append("file", element as any);
        });
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateVisitBaseDto} visit
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerCreate: async (
      visit: CreateVisitBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'visit' is not null or undefined
      assertParamExists("visitControllerCreate", "visit", visit);
      const localVarPath = `/api/v1/visit/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (visit !== undefined) {
        localVarFormParams.append("visit", JSON.stringify(visit));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteVisitDto} deleteVisitDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerDelete: async (
      deleteVisitDto: DeleteVisitDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteVisitDto' is not null or undefined
      assertParamExists(
        "visitControllerDelete",
        "deleteVisitDto",
        deleteVisitDto
      );
      const localVarPath = `/api/v1/visit/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteVisitDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditVisitBaseDto} visit
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerEdit: async (
      visit: EditVisitBaseDto,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'visit' is not null or undefined
      assertParamExists("visitControllerEdit", "visit", visit);
      const localVarPath = `/api/v1/visit/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (visit !== undefined) {
        localVarFormParams.append("visit", JSON.stringify(visit));
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerFixMissingVisits: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/visit/admin/fix-missing-visits`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/visit/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerGetAttachment: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/visit/attachment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VisitApi - functional programming interface
 * @export
 */
export const VisitApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VisitApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async visitControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.visitControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VisitApi.visitControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateAttachmentVisitBaseDto} attachment
     * @param {Array<File>} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async visitControllerAttachFile(
      attachment: CreateAttachmentVisitBaseDto,
      file?: Array<File>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.visitControllerAttachFile(
          attachment,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VisitApi.visitControllerAttachFile"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateVisitBaseDto} visit
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async visitControllerCreate(
      visit: CreateVisitBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.visitControllerCreate(
          visit,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VisitApi.visitControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteVisitDto} deleteVisitDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async visitControllerDelete(
      deleteVisitDto: DeleteVisitDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.visitControllerDelete(
          deleteVisitDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VisitApi.visitControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditVisitBaseDto} visit
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async visitControllerEdit(
      visit: EditVisitBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.visitControllerEdit(
          visit,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VisitApi.visitControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async visitControllerFixMissingVisits(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.visitControllerFixMissingVisits(
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VisitApi.visitControllerFixMissingVisits"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async visitControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<VisitControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.visitControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VisitApi.visitControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async visitControllerGetAttachment(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<VisitControllerGetAttachment200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.visitControllerGetAttachment(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VisitApi.visitControllerGetAttachment"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * VisitApi - factory interface
 * @export
 */
export const VisitApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = VisitApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .visitControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateAttachmentVisitBaseDto} attachment
     * @param {Array<File>} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerAttachFile(
      attachment: CreateAttachmentVisitBaseDto,
      file?: Array<File>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .visitControllerAttachFile(attachment, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateVisitBaseDto} visit
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerCreate(
      visit: CreateVisitBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .visitControllerCreate(visit, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteVisitDto} deleteVisitDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerDelete(
      deleteVisitDto: DeleteVisitDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .visitControllerDelete(deleteVisitDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditVisitBaseDto} visit
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerEdit(
      visit: EditVisitBaseDto,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .visitControllerEdit(visit, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerFixMissingVisits(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .visitControllerFixMissingVisits(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<VisitControllerGet200Response> {
      return localVarFp
        .visitControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    visitControllerGetAttachment(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<VisitControllerGetAttachment200Response> {
      return localVarFp
        .visitControllerGetAttachment(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * VisitApi - object-oriented interface
 * @export
 * @class VisitApi
 * @extends {BaseAPI}
 */
export class VisitApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VisitApi
   */
  public visitControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return VisitApiFp(this.configuration)
      .visitControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateAttachmentVisitBaseDto} attachment
   * @param {Array<File>} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VisitApi
   */
  public visitControllerAttachFile(
    attachment: CreateAttachmentVisitBaseDto,
    file?: Array<File>,
    options?: RawAxiosRequestConfig
  ) {
    return VisitApiFp(this.configuration)
      .visitControllerAttachFile(attachment, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateVisitBaseDto} visit
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VisitApi
   */
  public visitControllerCreate(
    visit: CreateVisitBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return VisitApiFp(this.configuration)
      .visitControllerCreate(visit, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteVisitDto} deleteVisitDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VisitApi
   */
  public visitControllerDelete(
    deleteVisitDto: DeleteVisitDto,
    options?: RawAxiosRequestConfig
  ) {
    return VisitApiFp(this.configuration)
      .visitControllerDelete(deleteVisitDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditVisitBaseDto} visit
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VisitApi
   */
  public visitControllerEdit(
    visit: EditVisitBaseDto,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return VisitApiFp(this.configuration)
      .visitControllerEdit(visit, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VisitApi
   */
  public visitControllerFixMissingVisits(options?: RawAxiosRequestConfig) {
    return VisitApiFp(this.configuration)
      .visitControllerFixMissingVisits(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VisitApi
   */
  public visitControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return VisitApiFp(this.configuration)
      .visitControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VisitApi
   */
  public visitControllerGetAttachment(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return VisitApiFp(this.configuration)
      .visitControllerGetAttachment(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * WaiverApi - axios parameter creator
 * @export
 */
export const WaiverApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerActivity: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/wavier/activity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateWaiverDto} createWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerCreate: async (
      createWaiverDto: CreateWaiverDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createWaiverDto' is not null or undefined
      assertParamExists(
        "waiverControllerCreate",
        "createWaiverDto",
        createWaiverDto
      );
      const localVarPath = `/api/v1/wavier/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createWaiverDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteWaiverDto} deleteWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerDelete: async (
      deleteWaiverDto: DeleteWaiverDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deleteWaiverDto' is not null or undefined
      assertParamExists(
        "waiverControllerDelete",
        "deleteWaiverDto",
        deleteWaiverDto
      );
      const localVarPath = `/api/v1/wavier/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteWaiverDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EditWaiverDto} editWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerEdit: async (
      editWaiverDto: EditWaiverDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'editWaiverDto' is not null or undefined
      assertParamExists("waiverControllerEdit", "editWaiverDto", editWaiverDto);
      const localVarPath = `/api/v1/wavier/edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editWaiverDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerGet: async (
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/wavier/get`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (order !== undefined) {
        for (const [key, value] of Object.entries(order)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (filter !== undefined) {
        for (const [key, value] of Object.entries(filter)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (dateFilter !== undefined) {
        localVarQueryParameter["date_filter"] = dateFilter;
      }

      if (startDate !== undefined) {
        for (const [key, value] of Object.entries(startDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endDate !== undefined) {
        for (const [key, value] of Object.entries(endDate)) {
          localVarQueryParameter[key] = value;
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WaiverApi - functional programming interface
 * @export
 */
export const WaiverApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WaiverApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PersonControllerActivity200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerActivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateWaiverDto} createWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerCreate(
      createWaiverDto: CreateWaiverDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerCreate(
          createWaiverDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerCreate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DeleteWaiverDto} deleteWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerDelete(
      deleteWaiverDto: DeleteWaiverDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerDelete(
          deleteWaiverDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {EditWaiverDto} editWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerEdit(
      editWaiverDto: EditWaiverDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<MessageResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerEdit(
          editWaiverDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerEdit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async waiverControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<WaiverControllerGet200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.waiverControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["WaiverApi.waiverControllerGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * WaiverApi - factory interface
 * @export
 */
export const WaiverApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = WaiverApiFp(configuration);
  return {
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerActivity(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PersonControllerActivity200Response> {
      return localVarFp
        .waiverControllerActivity(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateWaiverDto} createWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerCreate(
      createWaiverDto: CreateWaiverDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .waiverControllerCreate(createWaiverDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteWaiverDto} deleteWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerDelete(
      deleteWaiverDto: DeleteWaiverDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .waiverControllerDelete(deleteWaiverDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EditWaiverDto} editWaiverDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerEdit(
      editWaiverDto: EditWaiverDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MessageResponseDto> {
      return localVarFp
        .waiverControllerEdit(editWaiverDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [search]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {object} [order]
     * @param {object} [filter]
     * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
     * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    waiverControllerGet(
      search?: string,
      limit?: number,
      offset?: number,
      order?: object,
      filter?: object,
      dateFilter?: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<WaiverControllerGet200Response> {
      return localVarFp
        .waiverControllerGet(
          search,
          limit,
          offset,
          order,
          filter,
          dateFilter,
          startDate,
          endDate,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * WaiverApi - object-oriented interface
 * @export
 * @class WaiverApi
 * @extends {BaseAPI}
 */
export class WaiverApi extends BaseAPI {
  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerActivity(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerActivity(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateWaiverDto} createWaiverDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerCreate(
    createWaiverDto: CreateWaiverDto,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerCreate(createWaiverDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteWaiverDto} deleteWaiverDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerDelete(
    deleteWaiverDto: DeleteWaiverDto,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerDelete(deleteWaiverDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EditWaiverDto} editWaiverDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerEdit(
    editWaiverDto: EditWaiverDto,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerEdit(editWaiverDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [search]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {object} [order]
   * @param {object} [filter]
   * @param {string} [dateFilter] TODAY | YESTERDAY | WEEK | MONTH
   * @param {string} [startDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {string} [endDate] The date and time of the event. Format: YYYY-MM-DD
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WaiverApi
   */
  public waiverControllerGet(
    search?: string,
    limit?: number,
    offset?: number,
    order?: object,
    filter?: object,
    dateFilter?: string,
    startDate?: string,
    endDate?: string,
    options?: RawAxiosRequestConfig
  ) {
    return WaiverApiFp(this.configuration)
      .waiverControllerGet(
        search,
        limit,
        offset,
        order,
        filter,
        dateFilter,
        startDate,
        endDate,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
